export default {
  "transcript": [
    {
      "duration": 8160,
      "end_time": 28780,
      "speaker": "Speaker 0",
      "start_time": 20620,
      "text": "Welcome, ladies and gentlemen, to another edition of the MBLEX Test Prep Podcast. My name is David."
    },
    {
      "duration": 8820,
      "end_time": 37900,
      "speaker": "Speaker 0",
      "start_time": 29080,
      "text": "I am your host on this wonderful, fabulous, amazing journey through the world of the massage and bodywork licensing exam."
    },
    {
      "duration": 5200,
      "end_time": 43400,
      "speaker": "Speaker 0",
      "start_time": 38200,
      "text": "I know it's been a minute. I apologize for my absence from this podcast."
    },
    {
      "duration": 6380,
      "end_time": 50000,
      "speaker": "Speaker 0",
      "start_time": 43620,
      "text": "I've been really busy on a few things, a few things coming out, of course, that you'll want to check out."
    },
    {
      "duration": 4300,
      "end_time": 54640,
      "speaker": "Speaker 0",
      "start_time": 50340,
      "text": "So, of course, I have my study guide, my annual or semi-annual study guide."
    },
    {
      "duration": 1260,
      "end_time": 56260,
      "speaker": "Speaker 0",
      "start_time": 55000,
      "text": "Make sure you check that out."
    },
    {
      "duration": 9880,
      "end_time": 66240,
      "speaker": "Speaker 0",
      "start_time": 56360,
      "text": "Just go on to amazon.com, search for MBLEX Test Prep, and then whatever year you happen to be listening to this podcast in, you'll find my latest study guide for sure."
    },
    {
      "duration": 4960,
      "end_time": 71520,
      "speaker": "Speaker 0",
      "start_time": 66560,
      "text": "I have an app, the MBLEX Test Prep app, available for iPhone and Android."
    },
    {
      "duration": 6340,
      "end_time": 78020,
      "speaker": "Speaker 0",
      "start_time": 71680,
      "text": "You can find either of those. Just go on either the App Store or the Google Play Store."
    },
    {
      "duration": 5260,
      "end_time": 83480,
      "speaker": "Speaker 0",
      "start_time": 78220,
      "text": "Search for MBLEX Test Prep or Merlino's MBLEX Test Prep. That's M-E-R-L-I-N-O."
    },
    {
      "duration": 3380,
      "end_time": 87140,
      "speaker": "Speaker 0",
      "start_time": 83760,
      "text": "If it doesn't have my name on it, it's not my app, of course. Look for those."
    },
    {
      "duration": 8140,
      "end_time": 95440,
      "speaker": "Speaker 0",
      "start_time": 87300,
      "text": "You can sign up for a free account, take 125 practice test questions, and then an upgrade to the premium content, which I think is well worth it."
    },
    {
      "duration": 4680,
      "end_time": 100120,
      "speaker": "Speaker 0",
      "start_time": 95440,
      "text": "It's only 24.99. You get over 2,200 practice test questions."
    },
    {
      "duration": 5460,
      "end_time": 105580,
      "speaker": "Speaker 0",
      "start_time": 100120,
      "text": "You get over 1,600 pre-made flashcards. You get a matching assignment."
    },
    {
      "duration": 4080,
      "end_time": 109660,
      "speaker": "Speaker 0",
      "start_time": 105580,
      "text": "That's kind of like taking a test. Full content review."
    },
    {
      "duration": 5120,
      "end_time": 114920,
      "speaker": "Speaker 0",
      "start_time": 109800,
      "text": "Everything that you need to know for the MBLEX is in that app, just like the study guide."
    },
    {
      "duration": 4880,
      "end_time": 120120,
      "speaker": "Speaker 0",
      "start_time": 115240,
      "text": "Definitely check that out. I also have tutoring packages. Go to MBLEXTestPrepShop.com."
    },
    {
      "duration": 10260,
      "end_time": 130460,
      "speaker": "Speaker 0",
      "start_time": 120200,
      "text": "Pre-recorded tutoring packages, 25 hours of audio and video ready for you to start watching, listening to, and learning with as you prepare for the MBLEX."
    },
    {
      "duration": 7480,
      "end_time": 138780,
      "speaker": "Speaker 0",
      "start_time": 131300,
      "text": "This is a really important episode for anybody that wants to learn about sports injuries."
    },
    {
      "duration": 5540,
      "end_time": 144700,
      "speaker": "Speaker 0",
      "start_time": 139160,
      "text": "This interview is with a close personal friend of mine. His name is TJ Wilson."
    },
    {
      "duration": 4560,
      "end_time": 149760,
      "speaker": "Speaker 0",
      "start_time": 145200,
      "text": "Some of you might know him better as WWE wrestler Tyson Kidd."
    },
    {
      "duration": 4220,
      "end_time": 154400,
      "speaker": "Speaker 0",
      "start_time": 150180,
      "text": "He's had a couple major injuries in his career."
    },
    {
      "duration": 14140,
      "end_time": 168800,
      "speaker": "Speaker 0",
      "start_time": 154660,
      "text": "We talk about his career a little bit and then we talk about these injuries and how massage therapy really helps him in his rehabilitation and his everyday life now that he is, well, no longer a professional wrestler."
    },
    {
      "duration": 2460,
      "end_time": 171600,
      "speaker": "Speaker 0",
      "start_time": 169140,
      "text": "So definitely look forward to that."
    },
    {
      "duration": 2660,
      "end_time": 174520,
      "speaker": "Speaker 0",
      "start_time": 171860,
      "text": "I'm gonna take a quick break and then we'll jump into the interview."
    },
    {
      "duration": 4080,
      "end_time": 191310,
      "speaker": "Speaker 0",
      "start_time": 187230,
      "text": "Okay, so I am here with my close personal friend TJ Wilson."
    },
    {
      "duration": 6720,
      "end_time": 198370,
      "speaker": "Speaker 0",
      "start_time": 191650,
      "text": "For those of you who don't know, TJ is a professional wrestler, retired professional wrestler, I suppose, these days, right?"
    },
    {
      "duration": 1720,
      "end_time": 200330,
      "speaker": "Speaker 0",
      "start_time": 198610,
      "text": "Let's jump into your history a little bit."
    },
    {
      "duration": 4220,
      "end_time": 204770,
      "speaker": "Speaker 0",
      "start_time": 200550,
      "text": "How did you get started in the world of professional wrestling? The"
    },
    {
      "duration": 6600,
      "end_time": 211370,
      "speaker": "Speaker 1",
      "start_time": 204770,
      "text": "Way I look at it, I kind of somehow won a lottery or something and I happened to go to school with Teddy Hart."
    },
    {
      "duration": 4000,
      "end_time": 215610,
      "speaker": "Speaker 1",
      "start_time": 211610,
      "text": "He was like very persistent in me being, in us being friends."
    },
    {
      "duration": 4180,
      "end_time": 220010,
      "speaker": "Speaker 1",
      "start_time": 215830,
      "text": "I was not as warm to it as as he kind of was forcing it."
    },
    {
      "duration": 6000,
      "end_time": 226010,
      "speaker": "Speaker 1",
      "start_time": 220010,
      "text": "And once I kind of gave in, I was very happy with my choice. I just didn't know him at first."
    },
    {
      "duration": 11420,
      "end_time": 237430,
      "speaker": "Speaker 1",
      "start_time": 226010,
      "text": "And then once I got to know him a little bit and got to know his family, you know, the first time I went to his house, he lived in a gym, which like, you know, now as a 43 year old man, I know what a gym is."
    },
    {
      "duration": 3100,
      "end_time": 240830,
      "speaker": "Speaker 1",
      "start_time": 237730,
      "text": "When you're a 10 year old kid, a gym is the gymnasium."
    },
    {
      "duration": 4140,
      "end_time": 245190,
      "speaker": "Speaker 1",
      "start_time": 241050,
      "text": "It's, you know, the hardwood floor and stuff. So he kept saying he lived in a gym."
    },
    {
      "duration": 7700,
      "end_time": 253490,
      "speaker": "Speaker 1",
      "start_time": 245790,
      "text": "I remember going to his house and, you know, it was not what I expected and he introduced me to a woman that was on stationary bike."
    },
    {
      "duration": 4160,
      "end_time": 257990,
      "speaker": "Speaker 1",
      "start_time": 253830,
      "text": "He said, this is George. Well, I was in my head."
    },
    {
      "duration": 4641,
      "end_time": 262730,
      "speaker": "Speaker 1",
      "start_time": 258089,
      "text": "I'm like, why is he introducing me to gym members? George is his mom."
    },
    {
      "duration": 3260,
      "end_time": 266250,
      "speaker": "Speaker 1",
      "start_time": 262990,
      "text": "He's, I don't know that he's ever called his parents mom or dad a day in his life."
    },
    {
      "duration": 5540,
      "end_time": 271910,
      "speaker": "Speaker 1",
      "start_time": 266370,
      "text": "So like, right away, everything was just like, I'm getting hit with like, all this, just the stuff."
    },
    {
      "duration": 3540,
      "end_time": 275450,
      "speaker": "Speaker 1",
      "start_time": 271910,
      "text": "That's very different when, when you're a 10 year old kid compared to what I'm used to."
    },
    {
      "duration": 10820,
      "end_time": 286610,
      "speaker": "Speaker 1",
      "start_time": 275790,
      "text": "So I, you know, we go up to Sunday dinner and his grandfather, Stu Hart, who has a funny enough, he has a gym in his house too, but his is a wrestling gym down in the, in the basement."
    },
    {
      "duration": 8200,
      "end_time": 294810,
      "speaker": "Speaker 1",
      "start_time": 286610,
      "text": "And there's a ring set up outside when it's warm in Calgary, which is almost never, but, but there are, there is a little stretch where we get the ring set up."
    },
    {
      "duration": 3800,
      "end_time": 298890,
      "speaker": "Speaker 1",
      "start_time": 295090,
      "text": "So when I went to his house, it might've been the fall, it would've been the fall."
    },
    {
      "duration": 10360,
      "end_time": 309250,
      "speaker": "Speaker 1",
      "start_time": 298890,
      "text": "And like, at least in my, in my mind, the ring is set up, but probably not to be honest, but they were very, that like their whole family was very, very, very into professional wrestling."
    },
    {
      "duration": 4140,
      "end_time": 313650,
      "speaker": "Speaker 1",
      "start_time": 309510,
      "text": "And I'd, I'd watched a little bit of it with my cousin and I wasn't allowed to watch it."
    },
    {
      "duration": 4000,
      "end_time": 317730,
      "speaker": "Speaker 1",
      "start_time": 313730,
      "text": "Cause I came home and tried some of the moves on my younger sisters, my mom, we"
    },
    {
      "duration": 1340,
      "end_time": 319070,
      "speaker": "Speaker 0",
      "start_time": 317730,
      "text": "All did. We all did. Right."
    },
    {
      "duration": 5560,
      "end_time": 325530,
      "speaker": "Speaker 1",
      "start_time": 319970,
      "text": "My mom quickly banned wrestling, but I still had Ninja Turtles at the time. So I was okay."
    },
    {
      "duration": 3840,
      "end_time": 329370,
      "speaker": "Speaker 1",
      "start_time": 325530,
      "text": "I hadn't been, I hadn't been engulfed by wrestling yet."
    },
    {
      "duration": 2480,
      "end_time": 331870,
      "speaker": "Speaker 1",
      "start_time": 329390,
      "text": "Having hadn't been really bitten by that bug."
    },
    {
      "duration": 4520,
      "end_time": 336430,
      "speaker": "Speaker 1",
      "start_time": 331910,
      "text": "I watched it once, tried it and got it banned at my house."
    },
    {
      "duration": 10840,
      "end_time": 347450,
      "speaker": "Speaker 1",
      "start_time": 336610,
      "text": "So Summerslam 92, when I saw Brett, Brett versus the British Bulldog, Wembley stadium, that for some, whatever reason, that match told me, this is what I'm going to do."
    },
    {
      "duration": 3140,
      "end_time": 350810,
      "speaker": "Speaker 1",
      "start_time": 347670,
      "text": "I would love to have a chat with that 12 year old kid that watched that match."
    },
    {
      "duration": 1940,
      "end_time": 352770,
      "speaker": "Speaker 1",
      "start_time": 350830,
      "text": "And it was new for a fact he'd make it."
    },
    {
      "duration": 4260,
      "end_time": 357030,
      "speaker": "Speaker 1",
      "start_time": 352770,
      "text": "I'd love to have a chat with him and just know where the heck, where the hell his confidence came from, man."
    },
    {
      "duration": 320,
      "end_time": 357450,
      "speaker": "Speaker 1",
      "start_time": 357130,
      "text": "Is it?"
    },
    {
      "duration": 7480,
      "end_time": 365310,
      "speaker": "Speaker 0",
      "start_time": 357830,
      "text": "So, so after, after wrestling kind of grabbed you like that, how long did it take before you actually started breaking into the business?"
    },
    {
      "duration": 5660,
      "end_time": 371310,
      "speaker": "Speaker 1",
      "start_time": 365650,
      "text": "What happened was Harry and Teddy's brother, Matthew had a match in July of 1994."
    },
    {
      "duration": 3460,
      "end_time": 375210,
      "speaker": "Speaker 1",
      "start_time": 371750,
      "text": "And I was a wrestling fan at this point, obviously."
    },
    {
      "duration": 4520,
      "end_time": 380010,
      "speaker": "Speaker 1",
      "start_time": 375490,
      "text": "And like I said, the Summerslam 92 match, this is two years later. I remember Ted came by my house."
    },
    {
      "duration": 3720,
      "end_time": 383810,
      "speaker": "Speaker 1",
      "start_time": 380090,
      "text": "Well, he wanted me to come to the show and they were going to, we were going to bring my video camera."
    },
    {
      "duration": 3400,
      "end_time": 387350,
      "speaker": "Speaker 1",
      "start_time": 383950,
      "text": "I had a handheld camera and Ted didn't, and he wanted me to record this match."
    },
    {
      "duration": 5740,
      "end_time": 393670,
      "speaker": "Speaker 1",
      "start_time": 387930,
      "text": "And I was trying to not blow him up, but I had another friend over and I was like, I wasn't going to go to this show."
    },
    {
      "duration": 4220,
      "end_time": 398010,
      "speaker": "Speaker 1",
      "start_time": 393790,
      "text": "And my friend was like, Oh, I have to go home anyway. So I was like, man, okay, we'll go."
    },
    {
      "duration": 4380,
      "end_time": 402610,
      "speaker": "Speaker 1",
      "start_time": 398230,
      "text": "We went, Ted and I sat front row, someone else recorded the match so that we could like watch it."
    },
    {
      "duration": 3260,
      "end_time": 405930,
      "speaker": "Speaker 1",
      "start_time": 402670,
      "text": "We watched Ted and Ted's brother, Matthew and Harry wrestle."
    },
    {
      "duration": 13280,
      "end_time": 419270,
      "speaker": "Speaker 1",
      "start_time": 405990,
      "text": "And the matches is like only a little over like a minute long, but we sat there like, so in awe of them, how brave they were and how just the fact that they were like, they had this vision and here they were accomplishing it."
    },
    {
      "duration": 2360,
      "end_time": 422050,
      "speaker": "Speaker 1",
      "start_time": 419690,
      "text": "Harry's eight years old. Matt was 11 years old."
    },
    {
      "duration": 3680,
      "end_time": 426010,
      "speaker": "Speaker 1",
      "start_time": 422330,
      "text": "And we looked at each other and we're like, we're going to be in that ring next."
    },
    {
      "duration": 4080,
      "end_time": 430350,
      "speaker": "Speaker 1",
      "start_time": 426270,
      "text": "Stu had a long standing relationship with this little town in Alberta called Rockyford."
    },
    {
      "duration": 5080,
      "end_time": 435570,
      "speaker": "Speaker 1",
      "start_time": 430490,
      "text": "And so they would have a little rodeo every summer and he would do shows on the Saturday and the Sunday."
    },
    {
      "duration": 5160,
      "end_time": 441190,
      "speaker": "Speaker 1",
      "start_time": 436030,
      "text": "And then I remember we looked at each other and we knew about rock and we were like, next year, we're going to be wrestling at Roxy."
    },
    {
      "duration": 1580,
      "end_time": 443030,
      "speaker": "Speaker 1",
      "start_time": 441450,
      "text": "That was the goal."
    },
    {
      "duration": 500,
      "end_time": 443890,
      "speaker": "Speaker 0",
      "start_time": 443390,
      "text": "And it happened."
    },
    {
      "duration": 4920,
      "end_time": 449590,
      "speaker": "Speaker 1",
      "start_time": 444670,
      "text": "And it, and it happened. July 19, July 23rd, 1995. I had my first match."
    },
    {
      "duration": 1060,
      "end_time": 450670,
      "speaker": "Speaker 0",
      "start_time": 449610,
      "text": "So how old were you?"
    },
    {
      "duration": 1280,
      "end_time": 452010,
      "speaker": "Speaker 1",
      "start_time": 450730,
      "text": "Just turned 15."
    },
    {
      "duration": 3520,
      "end_time": 455910,
      "speaker": "Speaker 0",
      "start_time": 452390,
      "text": "Just turned 15, 15 years old. And you're already wrestling."
    },
    {
      "duration": 6580,
      "end_time": 462810,
      "speaker": "Speaker 0",
      "start_time": 456230,
      "text": "I was not wrestling when I was 15 years old, for sure. So you're 40, how old are you again?"
    },
    {
      "duration": 1300,
      "end_time": 464430,
      "speaker": "Speaker 1",
      "start_time": 463130,
      "text": "43. 43."
    },
    {
      "duration": 4580,
      "end_time": 469210,
      "speaker": "Speaker 0",
      "start_time": 464630,
      "text": "That's right. So you've been in the business now for 28"
    },
    {
      "duration": 340,
      "end_time": 469550,
      "speaker": "Speaker 1",
      "start_time": 469210,
      "text": "Years."
    },
    {
      "duration": 4460,
      "end_time": 474390,
      "speaker": "Speaker 0",
      "start_time": 469930,
      "text": "Yeah, almost 30 years. That's a lot of pro wrestling."
    },
    {
      "duration": 7600,
      "end_time": 482110,
      "speaker": "Speaker 0",
      "start_time": 474510,
      "text": "And, you know, for people that that aren't aware pro wrestling does take a quite a bit of a toll on your body, as we're going to discuss here."
    },
    {
      "duration": 3000,
      "end_time": 485390,
      "speaker": "Speaker 0",
      "start_time": 482390,
      "text": "Kind of the main topic of this, of this little podcast."
    },
    {
      "duration": 5560,
      "end_time": 491290,
      "speaker": "Speaker 0",
      "start_time": 485730,
      "text": "While you were active, you wrestled in Japan, Canada, US for different promotions, right?"
    },
    {
      "duration": 620,
      "end_time": 492790,
      "speaker": "Speaker 1",
      "start_time": 492170,
      "text": "Yeah, Europe."
    },
    {
      "duration": 5320,
      "end_time": 498310,
      "speaker": "Speaker 0",
      "start_time": 492990,
      "text": "It's kind of, it's kind of all over. So at what point were you full time on the road performing?"
    },
    {
      "duration": 4480,
      "end_time": 503710,
      "speaker": "Speaker 1",
      "start_time": 499230,
      "text": "So like 2005 is where I really started kind of wrestling full time-ish."
    },
    {
      "duration": 4480,
      "end_time": 508370,
      "speaker": "Speaker 1",
      "start_time": 503890,
      "text": "And then really, you know, stampede wrestling at that point is running every two weeks or sometimes every week."
    },
    {
      "duration": 4680,
      "end_time": 513130,
      "speaker": "Speaker 1",
      "start_time": 508450,
      "text": "And we'd have like, others, if you pick out a town in Alberta, I probably have wrestled there. How"
    },
    {
      "duration": 6860,
      "end_time": 519990,
      "speaker": "Speaker 0",
      "start_time": 513130,
      "text": "Often a week were you actually wrestling? Is it just once or twice, maybe on the weekends? Yeah"
    },
    {
      "duration": 880,
      "end_time": 521110,
      "speaker": "Speaker 1",
      "start_time": 520230,
      "text": "On the weekends, usually."
    },
    {
      "duration": 3940,
      "end_time": 525270,
      "speaker": "Speaker 1",
      "start_time": 521330,
      "text": "But, but the training with my Japanese trainer, sometimes it was five days a week."
    },
    {
      "duration": 3860,
      "end_time": 529210,
      "speaker": "Speaker 1",
      "start_time": 525350,
      "text": "And sometimes, as you get closer to like a two or something, we'd be doing seven days a week."
    },
    {
      "duration": 6860,
      "end_time": 536130,
      "speaker": "Speaker 1",
      "start_time": 529270,
      "text": "So seven days a week of like four or five hours of training and like a bunch of conditioning stuff, squats and things like that."
    },
    {
      "duration": 5360,
      "end_time": 541530,
      "speaker": "Speaker 1",
      "start_time": 536170,
      "text": "But then like hours of wrestling in the ring. You got"
    },
    {
      "duration": 3800,
      "end_time": 545330,
      "speaker": "Speaker 0",
      "start_time": 541530,
      "text": "To get your money's worth, right? They want you on the road. They want you in the ring for sure."
    },
    {
      "duration": 9160,
      "end_time": 555030,
      "speaker": "Speaker 0",
      "start_time": 545870,
      "text": "So leading up to 2006-2007, when things really start to take off for you, how much massage therapy were you receiving at that point?"
    },
    {
      "duration": 3540,
      "end_time": 559670,
      "speaker": "Speaker 1",
      "start_time": 556130,
      "text": "Not a whole lot. I remember a little bit."
    },
    {
      "duration": 6900,
      "end_time": 566650,
      "speaker": "Speaker 1",
      "start_time": 559750,
      "text": "I actually, I pinched a nerve, I thought in my neck at the time in 03, in between trips to Japan."
    },
    {
      "duration": 7020,
      "end_time": 573990,
      "speaker": "Speaker 1",
      "start_time": 566970,
      "text": "And I remember like, I got one or two massages in Calgary. And I felt better. But like, it's life."
    },
    {
      "duration": 5060,
      "end_time": 579210,
      "speaker": "Speaker 1",
      "start_time": 574150,
      "text": "A couple hours later, I'd start to get tight, my neck, my traps would get tight again, that numbness would come."
    },
    {
      "duration": 1140,
      "end_time": 580510,
      "speaker": "Speaker 1",
      "start_time": 579370,
      "text": "And you had"
    },
    {
      "duration": 2080,
      "end_time": 582590,
      "speaker": "Speaker 0",
      "start_time": 580510,
      "text": "Numbness like down your in your arm?"
    },
    {
      "duration": 2720,
      "end_time": 585930,
      "speaker": "Speaker 1",
      "start_time": 583210,
      "text": "Okay, yeah, down my arm. And of course, you know, we'll get there."
    },
    {
      "duration": 5040,
      "end_time": 591070,
      "speaker": "Speaker 1",
      "start_time": 586030,
      "text": "But in my mind, what's so crazy, I remember I was like, I know I have a. I know I have a broken neck."
    },
    {
      "duration": 4820,
      "end_time": 596010,
      "speaker": "Speaker 1",
      "start_time": 591190,
      "text": "I know I have a broken neck. I got this numbness. At that point, Edge had just gotten hurt."
    },
    {
      "duration": 3800,
      "end_time": 599810,
      "speaker": "Speaker 1",
      "start_time": 596010,
      "text": "A few guys prior to him with Rhino and a bunch, you know, a bunch of guys."
    },
    {
      "duration": 2760,
      "end_time": 602570,
      "speaker": "Speaker 1",
      "start_time": 599810,
      "text": "And I was like, I know it. I know it. And right."
    },
    {
      "duration": 5520,
      "end_time": 608550,
      "speaker": "Speaker 1",
      "start_time": 603030,
      "text": "It was my third tour Japan, one of the guys was like, because I wrestled a stampede kid there."
    },
    {
      "duration": 2640,
      "end_time": 611270,
      "speaker": "Speaker 1",
      "start_time": 608630,
      "text": "So they'd all call me, they'd use. most of them would call me kids on."
    },
    {
      "duration": 3000,
      "end_time": 614270,
      "speaker": "Speaker 1",
      "start_time": 611270,
      "text": "One of the guys was like kids on. you are very tough."
    },
    {
      "duration": 6260,
      "end_time": 620630,
      "speaker": "Speaker 1",
      "start_time": 614370,
      "text": "You never injury never trainers room. And then I was like, Yeah, I'm kind of faking it, man."
    },
    {
      "duration": 2580,
      "end_time": 623250,
      "speaker": "Speaker 1",
      "start_time": 620670,
      "text": "In my head. I'm thinking that. Right. And I was like, Wait a minute."
    },
    {
      "duration": 3000,
      "end_time": 626990,
      "speaker": "Speaker 1",
      "start_time": 623990,
      "text": "I'm so glad he's mentioned that I'm gonna go talk to the trainer right now about a massage."
    },
    {
      "duration": 4880,
      "end_time": 631870,
      "speaker": "Speaker 1",
      "start_time": 626990,
      "text": "And so I go there and I'm trying to. I'm explaining to him in like, I'm speaking broken English."
    },
    {
      "duration": 4380,
      "end_time": 636250,
      "speaker": "Speaker 1",
      "start_time": 631870,
      "text": "She's speaking broken English. Back to me about like, I'm trying to explain to him what's going on."
    },
    {
      "duration": 3680,
      "end_time": 640270,
      "speaker": "Speaker 1",
      "start_time": 636590,
      "text": "Like, I've seen like, I've seen like a wrestler in Japan be so beat up."
    },
    {
      "duration": 3540,
      "end_time": 643850,
      "speaker": "Speaker 1",
      "start_time": 640310,
      "text": "And then I go see the trainer and they put on some tape. Imagine everything's okay."
    },
    {
      "duration": 5040,
      "end_time": 649030,
      "speaker": "Speaker 1",
      "start_time": 643990,
      "text": "Or like, so anyway, the guy starts to work on me. And he said, Okay, he's explaining."
    },
    {
      "duration": 8240,
      "end_time": 657410,
      "speaker": "Speaker 1",
      "start_time": 649170,
      "text": "He said, When I push on you, if you feel like an electric shock, tell me, said, Okay, and I was explaining to him like, I was positive it was in my neck or whatever."
    },
    {
      "duration": 3080,
      "end_time": 660990,
      "speaker": "Speaker 1",
      "start_time": 657910,
      "text": "Dude, he starts like pushing. I'm like, he's kind of pushing on my chest."
    },
    {
      "duration": 5740,
      "end_time": 666750,
      "speaker": "Speaker 1",
      "start_time": 661010,
      "text": "And I'm just like, in my mind, I was like, what a waste of time. I'm like, No, no, no."
    },
    {
      "duration": 1260,
      "end_time": 668990,
      "speaker": "Speaker 1",
      "start_time": 667730,
      "text": "Yeah, right. Right there."
    },
    {
      "duration": 2520,
      "end_time": 672010,
      "speaker": "Speaker 0",
      "start_time": 669490,
      "text": "Exactly. That's how it always works."
    },
    {
      "duration": 1720,
      "end_time": 673930,
      "speaker": "Speaker 1",
      "start_time": 672210,
      "text": "He worked on me. And it was so much better."
    },
    {
      "duration": 2480,
      "end_time": 676510,
      "speaker": "Speaker 1",
      "start_time": 674030,
      "text": "I went home and I did get an x ray because I just wanted to be sure."
    },
    {
      "duration": 4660,
      "end_time": 681370,
      "speaker": "Speaker 1",
      "start_time": 676710,
      "text": "And they were like, Nope, you're next. Fine. You have a slight tilt. And they gave me this cream."
    },
    {
      "duration": 5380,
      "end_time": 687090,
      "speaker": "Speaker 1",
      "start_time": 681710,
      "text": "I'm going to pronounce it wrong. But like diclofenac gel or something like that."
    },
    {
      "duration": 6400,
      "end_time": 693490,
      "speaker": "Speaker 1",
      "start_time": 687090,
      "text": "It was a anti inflammatory said they're like, when you put it on your skin, you won't doesn't have a heating sensation or cooling sensation."
    },
    {
      "duration": 4380,
      "end_time": 697870,
      "speaker": "Speaker 1",
      "start_time": 693490,
      "text": "Like it's working layers down. So dude, I put it on one time."
    },
    {
      "duration": 5260,
      "end_time": 703130,
      "speaker": "Speaker 1",
      "start_time": 697870,
      "text": "And then like, I literally I remember I was up in our guest house that we lived in and was watching TV."
    },
    {
      "duration": 2840,
      "end_time": 705970,
      "speaker": "Speaker 1",
      "start_time": 703130,
      "text": "And just like, all of a sudden, I just started feeling this pulsating."
    },
    {
      "duration": 5820,
      "end_time": 712090,
      "speaker": "Speaker 1",
      "start_time": 706270,
      "text": "And then just like this release. I could feel like the feeling all coming back."
    },
    {
      "duration": 3940,
      "end_time": 716550,
      "speaker": "Speaker 1",
      "start_time": 712610,
      "text": "The only times that the feeling would like come back and I feel good is when I was resting and working out."
    },
    {
      "duration": 6860,
      "end_time": 723630,
      "speaker": "Speaker 1",
      "start_time": 716770,
      "text": "The problem was after doing those activities, how tight my neck and traps right body would get."
    },
    {
      "duration": 5920,
      "end_time": 729550,
      "speaker": "Speaker 1",
      "start_time": 723630,
      "text": "The numbness would almost feel like getting it back to kind of being numb felt worse than when it was actually numb, if that makes sense."
    },
    {
      "duration": 2620,
      "end_time": 732410,
      "speaker": "Speaker 0",
      "start_time": 729790,
      "text": "No, that completely understand for sure. And"
    },
    {
      "duration": 4620,
      "end_time": 737030,
      "speaker": "Speaker 1",
      "start_time": 732410,
      "text": "I was like, Okay, this guy fixed me. And okay, I'm a massage guy now."
    },
    {
      "duration": 3140,
      "end_time": 740530,
      "speaker": "Speaker 0",
      "start_time": 737390,
      "text": "Exactly. I all it takes is one and then you're hooked. Right?"
    },
    {
      "duration": 5780,
      "end_time": 746510,
      "speaker": "Speaker 0",
      "start_time": 740730,
      "text": "So when you're when you're full time working with WWE, how often are you getting massages then?"
    },
    {
      "duration": 3620,
      "end_time": 751110,
      "speaker": "Speaker 1",
      "start_time": 747490,
      "text": "Honestly, not that often at first, little bit here and there."
    },
    {
      "duration": 5440,
      "end_time": 756830,
      "speaker": "Speaker 1",
      "start_time": 751390,
      "text": "You know, when you first on the road in WWE, and you're on the road four or five days a week."
    },
    {
      "duration": 2380,
      "end_time": 759310,
      "speaker": "Speaker 1",
      "start_time": 756930,
      "text": "And it's just such a change."
    },
    {
      "duration": 4560,
      "end_time": 764110,
      "speaker": "Speaker 1",
      "start_time": 759550,
      "text": "Because before that, I'm in developmental, I'm in and I'm in FCW, I'm in the minor leagues, I'm in FCW."
    },
    {
      "duration": 3240,
      "end_time": 767590,
      "speaker": "Speaker 1",
      "start_time": 764350,
      "text": "So I'm like, I'm home every single night for like almost two years."
    },
    {
      "duration": 6560,
      "end_time": 774310,
      "speaker": "Speaker 1",
      "start_time": 767750,
      "text": "And then to go on the road, and you're on the road, four or five days a week, and every day is a different city, different town, different arena."
    },
    {
      "duration": 2820,
      "end_time": 777810,
      "speaker": "Speaker 1",
      "start_time": 774990,
      "text": "You just start to. you start to tell yourself, you don't have time for things."
    },
    {
      "duration": 2500,
      "end_time": 780470,
      "speaker": "Speaker 1",
      "start_time": 777970,
      "text": "I don't have time to get this massage, because I got to do this."
    },
    {
      "duration": 5600,
      "end_time": 786270,
      "speaker": "Speaker 1",
      "start_time": 780670,
      "text": "But the good thing is in WWE, they have a TV, they will have a massage therapist."
    },
    {
      "duration": 4460,
      "end_time": 790730,
      "speaker": "Speaker 1",
      "start_time": 786270,
      "text": "So I would once in a while get in there. But like, you know, you're brand new, I'm brand new."
    },
    {
      "duration": 7740,
      "end_time": 798490,
      "speaker": "Speaker 1",
      "start_time": 790750,
      "text": "So I've got to make sure like more senior guys that have the power don't, I'm not taking up their time."
    },
    {
      "duration": 2240,
      "end_time": 800930,
      "speaker": "Speaker 1",
      "start_time": 798690,
      "text": "They probably need"
    },
    {
      "duration": 1020,
      "end_time": 801950,
      "speaker": "Speaker 0",
      "start_time": 800930,
      "text": "It a lot more, right?"
    },
    {
      "duration": 400,
      "end_time": 802850,
      "speaker": "Speaker 1",
      "start_time": 802450,
      "text": "Exactly."
    },
    {
      "duration": 7240,
      "end_time": 810650,
      "speaker": "Speaker 1",
      "start_time": 803410,
      "text": "So but the truth is, a little bit later, a couple of years on the road is where I start really getting massages regularly."
    },
    {
      "duration": 220,
      "end_time": 811170,
      "speaker": "Speaker 1",
      "start_time": 810950,
      "text": "Do"
    },
    {
      "duration": 4320,
      "end_time": 815490,
      "speaker": "Speaker 0",
      "start_time": 811170,
      "text": "They bring a massage therapist in locally? Do they do they find somebody locally?"
    },
    {
      "duration": 2300,
      "end_time": 818070,
      "speaker": "Speaker 0",
      "start_time": 815770,
      "text": "Do they have somebody traveling with them?"
    },
    {
      "duration": 720,
      "end_time": 818890,
      "speaker": "Speaker 1",
      "start_time": 818170,
      "text": "No, locally."
    },
    {
      "duration": 4760,
      "end_time": 824090,
      "speaker": "Speaker 0",
      "start_time": 819330,
      "text": "Do you know how how they find those people? Or does just somebody know somebody?"
    },
    {
      "duration": 6920,
      "end_time": 831750,
      "speaker": "Speaker 1",
      "start_time": 824830,
      "text": "I think it's just, it's just somebody knows somebody or like, somebody is put in charge of it."
    },
    {
      "duration": 2500,
      "end_time": 834290,
      "speaker": "Speaker 1",
      "start_time": 831790,
      "text": "And maybe it's the same person every town. I don't know."
    },
    {
      "duration": 5220,
      "end_time": 839570,
      "speaker": "Speaker 1",
      "start_time": 834350,
      "text": "And then they, they just probably, you know, Google or something. Networking."
    },
    {
      "duration": 440,
      "end_time": 840110,
      "speaker": "Speaker 0",
      "start_time": 839670,
      "text": "I know that"
    },
    {
      "duration": 680,
      "end_time": 840790,
      "speaker": "Speaker 1",
      "start_time": 840110,
      "text": "We have tried"
    },
    {
      "duration": 520,
      "end_time": 841690,
      "speaker": "Speaker 0",
      "start_time": 841170,
      "text": "We have tried"
    },
    {
      "duration": 2720,
      "end_time": 844410,
      "speaker": "Speaker 1",
      "start_time": 841690,
      "text": "To get it. We have tried to get a this girl."
    },
    {
      "duration": 6100,
      "end_time": 850510,
      "speaker": "Speaker 1",
      "start_time": 844410,
      "text": "That's really good. We tried getting like the company to like sign her but it just I don't know."
    },
    {
      "duration": 7540,
      "end_time": 858410,
      "speaker": "Speaker 1",
      "start_time": 850870,
      "text": "There is a. they were very against it at that time. And I don't really know. I don't know the what."
    },
    {
      "duration": 1000,
      "end_time": 859410,
      "speaker": "Speaker 0",
      "start_time": 858410,
      "text": "How long ago was that?"
    },
    {
      "duration": 3580,
      "end_time": 863410,
      "speaker": "Speaker 1",
      "start_time": 859830,
      "text": "A little before the pandemic. I think the boys were trying to push back. I was."
    },
    {
      "duration": 3620,
      "end_time": 867030,
      "speaker": "Speaker 0",
      "start_time": 863410,
      "text": "I was thinking it would be a way way earlier than that."
    },
    {
      "duration": 6180,
      "end_time": 873490,
      "speaker": "Speaker 1",
      "start_time": 867310,
      "text": "I think they used to have a chiropractor maybe full time. I don't know 100 percent for sure."
    },
    {
      "duration": 4900,
      "end_time": 878950,
      "speaker": "Speaker 0",
      "start_time": 874050,
      "text": "Gotcha. So once in a while you get a massage while you're performing, right?"
    },
    {
      "duration": 5480,
      "end_time": 884730,
      "speaker": "Speaker 0",
      "start_time": 879250,
      "text": "What kind of massages would you be getting? Are they just kind of maintenance massages?"
    },
    {
      "duration": 840,
      "end_time": 885730,
      "speaker": "Speaker 0",
      "start_time": 884890,
      "text": "Are you doing anything?"
    },
    {
      "duration": 4300,
      "end_time": 891130,
      "speaker": "Speaker 0",
      "start_time": 886830,
      "text": "Are you doing massages at the shows beforehand between the shows?"
    },
    {
      "duration": 3360,
      "end_time": 894510,
      "speaker": "Speaker 0",
      "start_time": 891150,
      "text": "And what kind of massages are you getting with that?"
    },
    {
      "duration": 7420,
      "end_time": 902610,
      "speaker": "Speaker 1",
      "start_time": 895190,
      "text": "Usually I'm getting deep tissue and it would be usually like in between being on the road."
    },
    {
      "duration": 3020,
      "end_time": 905710,
      "speaker": "Speaker 1",
      "start_time": 902690,
      "text": "Like normally I would for the most part, I'd get them when I would come home."
    },
    {
      "duration": 6600,
      "end_time": 912470,
      "speaker": "Speaker 1",
      "start_time": 905870,
      "text": "I wouldn't really get them like like if I got banged up with something, I might go get a massage from the person at TV."
    },
    {
      "duration": 4580,
      "end_time": 917310,
      "speaker": "Speaker 1",
      "start_time": 912730,
      "text": "But like I said, I don't want to step on anybody's toes and especially the wrong person's toes."
    },
    {
      "duration": 5100,
      "end_time": 922650,
      "speaker": "Speaker 1",
      "start_time": 917550,
      "text": "Maybe their toes are extra sore. So I got to make sure I really don't step on those toes."
    },
    {
      "duration": 3920,
      "end_time": 926970,
      "speaker": "Speaker 0",
      "start_time": 923050,
      "text": "Exactly. A lot of politics go into the backstage area."
    },
    {
      "duration": 3040,
      "end_time": 930170,
      "speaker": "Speaker 0",
      "start_time": 927130,
      "text": "You don't want to mess with anybody. And of course, I'm explaining all this."
    },
    {
      "duration": 3180,
      "end_time": 933450,
      "speaker": "Speaker 0",
      "start_time": 930270,
      "text": "Like, of course, I know that everybody that doesn't know there's."
    },
    {
      "duration": 3860,
      "end_time": 937310,
      "speaker": "Speaker 0",
      "start_time": 933450,
      "text": "There's a lot more that goes into into the pro wrestling environment than you might think."
    },
    {
      "duration": 140,
      "end_time": 937710,
      "speaker": "Speaker 1",
      "start_time": 937570,
      "text": "Yeah."
    },
    {
      "duration": 2780,
      "end_time": 940770,
      "speaker": "Speaker 0",
      "start_time": 937990,
      "text": "OK, so let's talk about one of your one of your injuries."
    },
    {
      "duration": 5820,
      "end_time": 947030,
      "speaker": "Speaker 0",
      "start_time": 941210,
      "text": "You destroyed your knee during a house show. That's like an untelevised show."
    },
    {
      "duration": 2360,
      "end_time": 949730,
      "speaker": "Speaker 0",
      "start_time": 947370,
      "text": "What what happened with that? What were your injuries?"
    },
    {
      "duration": 5480,
      "end_time": 955210,
      "speaker": "Speaker 0",
      "start_time": 949730,
      "text": "And just just kind of lay out everything that went into that specific injury?"
    },
    {
      "duration": 4580,
      "end_time": 960370,
      "speaker": "Speaker 1",
      "start_time": 955790,
      "text": "I always joke around that the crowd was like the crowd was rocking the crowd."
    },
    {
      "duration": 7420,
      "end_time": 968150,
      "speaker": "Speaker 1",
      "start_time": 960730,
      "text": "If that audience wasn't so so hot, I wouldn't have got hurt that day. Right. Listen"
    },
    {
      "duration": 2140,
      "end_time": 970430,
      "speaker": "Speaker 0",
      "start_time": 968290,
      "text": "It just gets to you, right?"
    },
    {
      "duration": 280,
      "end_time": 971250,
      "speaker": "Speaker 1",
      "start_time": 970970,
      "text": "No."
    },
    {
      "duration": 7580,
      "end_time": 979010,
      "speaker": "Speaker 1",
      "start_time": 971430,
      "text": "We were in Green Bay and it was a spot and I'm I'm going to get thrown out of the ring and I'm going to go through the ropes."
    },
    {
      "duration": 940,
      "end_time": 980070,
      "speaker": "Speaker 1",
      "start_time": 979130,
      "text": "And I actually I would."
    },
    {
      "duration": 4760,
      "end_time": 984830,
      "speaker": "Speaker 1",
      "start_time": 980070,
      "text": "I would take a pretty like gnarly looking bump all the time when I would take."
    },
    {
      "duration": 4480,
      "end_time": 989310,
      "speaker": "Speaker 1",
      "start_time": 984830,
      "text": "Just something I kind of learned to do in my bump"
    },
    {
      "duration": 2480,
      "end_time": 991790,
      "speaker": "Speaker 0",
      "start_time": 989310,
      "text": "Is when you when you land, like when"
    },
    {
      "duration": 1700,
      "end_time": 993490,
      "speaker": "Speaker 1",
      "start_time": 991790,
      "text": "You take a fall. Right."
    },
    {
      "duration": 8780,
      "end_time": 1002410,
      "speaker": "Speaker 1",
      "start_time": 993630,
      "text": "So I get thrown through the ropes and I would generally I would almost like front roll, but like it almost and then into a fall onto the floor."
    },
    {
      "duration": 5500,
      "end_time": 1007910,
      "speaker": "Speaker 1",
      "start_time": 1002410,
      "text": "And I was very accurate at it and it didn't hurt me. I never got hurt on that bump."
    },
    {
      "duration": 3980,
      "end_time": 1012110,
      "speaker": "Speaker 1",
      "start_time": 1008130,
      "text": "And it actually looks more gruesome than what ends up happening."
    },
    {
      "duration": 5760,
      "end_time": 1018010,
      "speaker": "Speaker 1",
      "start_time": 1012250,
      "text": "But anyway, I. The crowd was rocking like they were so loud, it was awesome."
    },
    {
      "duration": 6320,
      "end_time": 1024550,
      "speaker": "Speaker 1",
      "start_time": 1018230,
      "text": "And as I'm getting thrown out in my mind, I was like, OK, I want to give them a little extra."
    },
    {
      "duration": 3000,
      "end_time": 1027710,
      "speaker": "Speaker 1",
      "start_time": 1024710,
      "text": "I thought I was me. I could maybe like almost."
    },
    {
      "duration": 6619,
      "end_time": 1034329,
      "speaker": "Speaker 1",
      "start_time": 1027710,
      "text": "We have like steel grates as as the barricade, you know, between the ring and the fans."
    },
    {
      "duration": 3481,
      "end_time": 1038050,
      "speaker": "Speaker 1",
      "start_time": 1034569,
      "text": "And it's not. we have a few feet outside the ring to play with."
    },
    {
      "duration": 4021,
      "end_time": 1042130,
      "speaker": "Speaker 1",
      "start_time": 1038109,
      "text": "And, you know, we use the barricades as a as a weapon a lot."
    },
    {
      "duration": 5680,
      "end_time": 1048390,
      "speaker": "Speaker 1",
      "start_time": 1042710,
      "text": "Last second, as I'm getting thrown through, I was like, I'm going to dive like straight."
    },
    {
      "duration": 2160,
      "end_time": 1050890,
      "speaker": "Speaker 1",
      "start_time": 1048730,
      "text": "And the thing that's going to break my fall is that barricade."
    },
    {
      "duration": 1800,
      "end_time": 1052790,
      "speaker": "Speaker 1",
      "start_time": 1050990,
      "text": "Like I'm going to crash in that barricade."
    },
    {
      "duration": 2940,
      "end_time": 1056250,
      "speaker": "Speaker 1",
      "start_time": 1053310,
      "text": "Like I want this to look ugly, like these people are with this."
    },
    {
      "duration": 1580,
      "end_time": 1058010,
      "speaker": "Speaker 1",
      "start_time": 1056430,
      "text": "I want I want to give them everything."
    },
    {
      "duration": 3860,
      "end_time": 1062450,
      "speaker": "Speaker 1",
      "start_time": 1058590,
      "text": "And that's what I was going to do as my head goes through the ropes."
    },
    {
      "duration": 3540,
      "end_time": 1066250,
      "speaker": "Speaker 1",
      "start_time": 1062710,
      "text": "I was like, oh, that's a little far."
    },
    {
      "duration": 4420,
      "end_time": 1070770,
      "speaker": "Speaker 1",
      "start_time": 1066350,
      "text": "It's a little further than I thought when I was in the middle of the ring, getting taken towards the ropes."
    },
    {
      "duration": 3540,
      "end_time": 1074310,
      "speaker": "Speaker 1",
      "start_time": 1070770,
      "text": "As I'm getting as I get to the ropes. I realize it's a little further than I thought."
    },
    {
      "duration": 500,
      "end_time": 1075150,
      "speaker": "Speaker 0",
      "start_time": 1074650,
      "text": "It's"
    },
    {
      "duration": 4500,
      "end_time": 1079650,
      "speaker": "Speaker 1",
      "start_time": 1075150,
      "text": "The only time I think probably in my career where I second guess something once I committed to it."
    },
    {
      "duration": 5440,
      "end_time": 1085350,
      "speaker": "Speaker 1",
      "start_time": 1079910,
      "text": "And I was like, OK, you know what? I'll just rotate over. I'll land on my feet and fall."
    },
    {
      "duration": 5000,
      "end_time": 1090530,
      "speaker": "Speaker 1",
      "start_time": 1085530,
      "text": "Like I'll land on my feet as close as I can to the barricade and fall into it almost in one motion."
    },
    {
      "duration": 6320,
      "end_time": 1097210,
      "speaker": "Speaker 1",
      "start_time": 1090890,
      "text": "And when I landed, I landed all on my right foot and it was completely straight."
    },
    {
      "duration": 2300,
      "end_time": 1099790,
      "speaker": "Speaker 1",
      "start_time": 1097490,
      "text": "And so I hyperextended the hell out of my knee."
    },
    {
      "duration": 7320,
      "end_time": 1107350,
      "speaker": "Speaker 1",
      "start_time": 1100030,
      "text": "In my mind, I'm stuck on this one foot trying to fall into the barricade for like five seconds."
    },
    {
      "duration": 2400,
      "end_time": 1109830,
      "speaker": "Speaker 1",
      "start_time": 1107430,
      "text": "Like I just. and then finally I I fall and I hit."
    },
    {
      "duration": 3940,
      "end_time": 1113770,
      "speaker": "Speaker 1",
      "start_time": 1109830,
      "text": "I remember how I remember putting my hands up. I don't remember any of that."
    },
    {
      "duration": 2740,
      "end_time": 1116990,
      "speaker": "Speaker 1",
      "start_time": 1114250,
      "text": "Remember laying down and I can clear as day."
    },
    {
      "duration": 4820,
      "end_time": 1121890,
      "speaker": "Speaker 1",
      "start_time": 1117070,
      "text": "I remember the suspense and man, that looked like it hurt. And I was thinking, not my face."
    },
    {
      "duration": 2660,
      "end_time": 1124710,
      "speaker": "Speaker 1",
      "start_time": 1122050,
      "text": "I was down face down and I'm supposed to feed up for something."
    },
    {
      "duration": 4300,
      "end_time": 1129770,
      "speaker": "Speaker 1",
      "start_time": 1125470,
      "text": "A wrestler, Jinder Mahal, was supposed to hit me with a flying knee behind the reps back."
    },
    {
      "duration": 5620,
      "end_time": 1135730,
      "speaker": "Speaker 1",
      "start_time": 1130110,
      "text": "And I just laid face first on the floor because I could not bend my knee, my right knee."
    },
    {
      "duration": 1260,
      "end_time": 1137150,
      "speaker": "Speaker 1",
      "start_time": 1135890,
      "text": "I couldn't couldn't move it."
    },
    {
      "duration": 1300,
      "end_time": 1139350,
      "speaker": "Speaker 0",
      "start_time": 1138050,
      "text": "What structurally was damaged?"
    },
    {
      "duration": 11360,
      "end_time": 1151350,
      "speaker": "Speaker 1",
      "start_time": 1139990,
      "text": "I tore my ACL, my MCL, my meniscus, my LCL, and I had a tibia plateau fracture."
    },
    {
      "duration": 5320,
      "end_time": 1157210,
      "speaker": "Speaker 1",
      "start_time": 1151890,
      "text": "So and so when I saw Dr. Andrews, so when he did his little he did his test."
    },
    {
      "duration": 680,
      "end_time": 1158590,
      "speaker": "Speaker 0",
      "start_time": 1157910,
      "text": "What the Lockman?"
    },
    {
      "duration": 5160,
      "end_time": 1163750,
      "speaker": "Speaker 0",
      "start_time": 1158590,
      "text": "Lockman test where you take the knee and kind of or the leg and shift it and see how much play underneath."
    },
    {
      "duration": 1460,
      "end_time": 1165710,
      "speaker": "Speaker 1",
      "start_time": 1164250,
      "text": "For those that don't know, like Dr."
    },
    {
      "duration": 4720,
      "end_time": 1170430,
      "speaker": "Speaker 1",
      "start_time": 1165710,
      "text": "Andrews is like the man when it comes to ACL surgeries, ACL repair."
    },
    {
      "duration": 5940,
      "end_time": 1177290,
      "speaker": "Speaker 1",
      "start_time": 1171350,
      "text": "I mean, maybe maybe most athletic surgeries, period. But ACL, he's the guru."
    },
    {
      "duration": 3980,
      "end_time": 1181570,
      "speaker": "Speaker 1",
      "start_time": 1177590,
      "text": "And he he literally like touched my knees again. Yeah."
    },
    {
      "duration": 4100,
      "end_time": 1185930,
      "speaker": "Speaker 1",
      "start_time": 1181830,
      "text": "But then he then he went and I really took a lot of pride in this."
    },
    {
      "duration": 3080,
      "end_time": 1189090,
      "speaker": "Speaker 1",
      "start_time": 1186010,
      "text": "And he came back after he went and looked at the imaging and came back."
    },
    {
      "duration": 4020,
      "end_time": 1193690,
      "speaker": "Speaker 1",
      "start_time": 1189670,
      "text": "He said, you told me you're not in pain. I said, well, like, I'm not like it didn't."
    },
    {
      "duration": 4140,
      "end_time": 1197990,
      "speaker": "Speaker 1",
      "start_time": 1193850,
      "text": "Once it was torn and stuff, a doctor here in Tampa, I went and saw him."
    },
    {
      "duration": 1680,
      "end_time": 1199790,
      "speaker": "Speaker 1",
      "start_time": 1198110,
      "text": "That was where I got the MRI and stuff."
    },
    {
      "duration": 4100,
      "end_time": 1204030,
      "speaker": "Speaker 1",
      "start_time": 1199930,
      "text": "And he actually got 30 cc's of fluid and blood out of my knee."
    },
    {
      "duration": 4620,
      "end_time": 1209230,
      "speaker": "Speaker 1",
      "start_time": 1204610,
      "text": "And once he took that out, it felt it felt really good. I didn't just to"
    },
    {
      "duration": 2280,
      "end_time": 1211510,
      "speaker": "Speaker 0",
      "start_time": 1209230,
      "text": "Relieve that pressure, because it's probably just inflammation."
    },
    {
      "duration": 3820,
      "end_time": 1215350,
      "speaker": "Speaker 0",
      "start_time": 1211530,
      "text": "That's what was causing the the pain that you were feeling. But yeah"
    },
    {
      "duration": 6180,
      "end_time": 1221790,
      "speaker": "Speaker 1",
      "start_time": 1215610,
      "text": "So then so when I went to Dr. Andrews a couple of weeks after the guy took the 30 cc's out."
    },
    {
      "duration": 3020,
      "end_time": 1224810,
      "speaker": "Speaker 1",
      "start_time": 1221790,
      "text": "So. And my knee wasn't even really that swollen."
    },
    {
      "duration": 4880,
      "end_time": 1229870,
      "speaker": "Speaker 1",
      "start_time": 1224990,
      "text": "I don't know where this stuff just kept coming from, but anyway, he. Dr."
    },
    {
      "duration": 2320,
      "end_time": 1232270,
      "speaker": "Speaker 1",
      "start_time": 1229950,
      "text": "Andrews came in and he said, hey, you told me you're not in pain. I said, I'm not."
    },
    {
      "duration": 4560,
      "end_time": 1236910,
      "speaker": "Speaker 1",
      "start_time": 1232350,
      "text": "He said, well, you're one of the toughest guys I've seen. And he's like your knee."
    },
    {
      "duration": 2880,
      "end_time": 1240230,
      "speaker": "Speaker 1",
      "start_time": 1237350,
      "text": "He said your knee is almost it's almost a complete dislocation."
    },
    {
      "duration": 5700,
      "end_time": 1246370,
      "speaker": "Speaker 1",
      "start_time": 1240670,
      "text": "And I was like, oh, I mean, I guess when when TJ does things, I do things I do things as big as I can."
    },
    {
      "duration": 4560,
      "end_time": 1251130,
      "speaker": "Speaker 0",
      "start_time": 1246570,
      "text": "Yeah, you go all out for sure. So you had everything repaired, right?"
    },
    {
      "duration": 4240,
      "end_time": 1255370,
      "speaker": "Speaker 0",
      "start_time": 1251130,
      "text": "Yeah. How long was your rehab and was massage therapy part of that rehab?"
    },
    {
      "duration": 11680,
      "end_time": 1267870,
      "speaker": "Speaker 1",
      "start_time": 1256190,
      "text": "Yeah, actually, like almost right away, massage there because of the tibia plateau fracture here in Tampa, the the the doctor that saw me thought that I had to wait for that fracture to heal before the surgery."
    },
    {
      "duration": 4280,
      "end_time": 1272250,
      "speaker": "Speaker 1",
      "start_time": 1267970,
      "text": "So I was already going to this place D1 and I was doing prehab."
    },
    {
      "duration": 2940,
      "end_time": 1275450,
      "speaker": "Speaker 1",
      "start_time": 1272510,
      "text": "They expect to see me on Monday for more prehab."
    },
    {
      "duration": 4500,
      "end_time": 1280170,
      "speaker": "Speaker 1",
      "start_time": 1275670,
      "text": "And then here I come walking in on crutches and post surgery. Right."
    },
    {
      "duration": 3320,
      "end_time": 1284030,
      "speaker": "Speaker 1",
      "start_time": 1280710,
      "text": "That they didn't know about. And they were like, oh, this is different."
    },
    {
      "duration": 4340,
      "end_time": 1288590,
      "speaker": "Speaker 1",
      "start_time": 1284250,
      "text": "So then that's when the massages really started. They would they would massage my knee for like it."
    },
    {
      "duration": 11760,
      "end_time": 1300390,
      "speaker": "Speaker 1",
      "start_time": 1288630,
      "text": "Massages gel into my knee for like 20 minutes before every therapy session and like 20 minutes after is the best is the best part is when he's massaging it before the rehab."
    },
    {
      "duration": 4160,
      "end_time": 1305010,
      "speaker": "Speaker 1",
      "start_time": 1300850,
      "text": "It feels really good. But I know like, OK, now I got to go do all this work on this knee."
    },
    {
      "duration": 4580,
      "end_time": 1309730,
      "speaker": "Speaker 1",
      "start_time": 1305150,
      "text": "When you'd be massaging at the end of the of the session, it would be like, oh, this is over."
    },
    {
      "duration": 1360,
      "end_time": 1311410,
      "speaker": "Speaker 1",
      "start_time": 1310050,
      "text": "Today's over. Thank God."
    },
    {
      "duration": 4640,
      "end_time": 1316510,
      "speaker": "Speaker 1",
      "start_time": 1311870,
      "text": "His name is Al. The two two guys that worked with the D1, Al and Mitch, they were amazing."
    },
    {
      "duration": 4900,
      "end_time": 1321770,
      "speaker": "Speaker 1",
      "start_time": 1316870,
      "text": "I was going three days a week, probably three hours at a time, especially once I started getting a lot more mobility."
    },
    {
      "duration": 4120,
      "end_time": 1326370,
      "speaker": "Speaker 1",
      "start_time": 1322250,
      "text": "I remember asking, I said, hey, can I come? I just wanted to get better."
    },
    {
      "duration": 4480,
      "end_time": 1330930,
      "speaker": "Speaker 1",
      "start_time": 1326450,
      "text": "And I was like, can I come five days a week? And they're like, no, no, no, no, no."
    },
    {
      "duration": 5220,
      "end_time": 1336150,
      "speaker": "Speaker 1",
      "start_time": 1330930,
      "text": "We work you so hard. You need that recovery day. Exactly. Like, are you sure?"
    },
    {
      "duration": 3300,
      "end_time": 1339610,
      "speaker": "Speaker 1",
      "start_time": 1336310,
      "text": "Like, yeah, OK, just make sure I'm like"
    },
    {
      "duration": 1800,
      "end_time": 1341470,
      "speaker": "Speaker 0",
      "start_time": 1339670,
      "text": "Calm down, just calm down. You'll get"
    },
    {
      "duration": 1440,
      "end_time": 1342910,
      "speaker": "Speaker 1",
      "start_time": 1341470,
      "text": "Better. You'll get better now."
    },
    {
      "duration": 2760,
      "end_time": 1345890,
      "speaker": "Speaker 1",
      "start_time": 1343130,
      "text": "And telling me, hey, this is the first time you've ever been like injured, injured."
    },
    {
      "duration": 5060,
      "end_time": 1351170,
      "speaker": "Speaker 1",
      "start_time": 1346110,
      "text": "We know that you're like crazy, good, crazy, but crazy. Relax."
    },
    {
      "duration": 3320,
      "end_time": 1354590,
      "speaker": "Speaker 1",
      "start_time": 1351270,
      "text": "Take this time. And don't don't be a maniac of like."
    },
    {
      "duration": 4080,
      "end_time": 1358670,
      "speaker": "Speaker 1",
      "start_time": 1354590,
      "text": "You got to get back in crazy. Now a name drop a little bit."
    },
    {
      "duration": 3900,
      "end_time": 1362590,
      "speaker": "Speaker 1",
      "start_time": 1358690,
      "text": "But I remember a rest. So I got hurt in January in December."
    },
    {
      "duration": 9680,
      "end_time": 1372350,
      "speaker": "Speaker 1",
      "start_time": 1362670,
      "text": "My surgery is in January 2013. I go up to WrestleMania in New York that year in March 2013. So."
    },
    {
      "duration": 7260,
      "end_time": 1380430,
      "speaker": "Speaker 1",
      "start_time": 1373170,
      "text": "Three months after my surgery, three and a bit, I see Randy Orton and he was funny, he was like, he said, man, I loved it."
    },
    {
      "duration": 2780,
      "end_time": 1383330,
      "speaker": "Speaker 1",
      "start_time": 1380550,
      "text": "And I was like, what do you mean? He's like, well, he asked me how my knee was."
    },
    {
      "duration": 3980,
      "end_time": 1387330,
      "speaker": "Speaker 1",
      "start_time": 1383350,
      "text": "And then he was like, he said, well, he said, I like how pale you are right now."
    },
    {
      "duration": 2100,
      "end_time": 1389430,
      "speaker": "Speaker 1",
      "start_time": 1387330,
      "text": "And like, you're not as quite as Jack."
    },
    {
      "duration": 7580,
      "end_time": 1397070,
      "speaker": "Speaker 1",
      "start_time": 1389490,
      "text": "He's like, so I can tell that you're like you're not going crazy with this, like not being on the road, which he was right."
    },
    {
      "duration": 3820,
      "end_time": 1400990,
      "speaker": "Speaker 1",
      "start_time": 1397170,
      "text": "I mean, obviously it's a it's a balance and it's everyone's going to be different."
    },
    {
      "duration": 8840,
      "end_time": 1410010,
      "speaker": "Speaker 1",
      "start_time": 1401170,
      "text": "And it's a matter of like, OK, when your life just changes, when you're on the road 24 seven and all of a sudden it goes from like 100 to zero, it's a change, man."
    },
    {
      "duration": 2600,
      "end_time": 1412630,
      "speaker": "Speaker 1",
      "start_time": 1410030,
      "text": "Just like going from zero to 100 is a giant change."
    },
    {
      "duration": 6380,
      "end_time": 1419210,
      "speaker": "Speaker 0",
      "start_time": 1412830,
      "text": "So, OK, so after you're recovered, you start back in with the wrestling and everything, right?"
    },
    {
      "duration": 1060,
      "end_time": 1421270,
      "speaker": "Speaker 1",
      "start_time": 1420210,
      "text": "With my knee yesterday. Yep."
    },
    {
      "duration": 5700,
      "end_time": 1427230,
      "speaker": "Speaker 0",
      "start_time": 1421530,
      "text": "And you're back to doing like just the maintenance massage in between shows and everything, right?"
    },
    {
      "duration": 220,
      "end_time": 1427690,
      "speaker": "Speaker 0",
      "start_time": 1427470,
      "text": "Yeah."
    },
    {
      "duration": 6660,
      "end_time": 1434450,
      "speaker": "Speaker 1",
      "start_time": 1427790,
      "text": "And in my time where I had that run, I did have my knee surgery and I was at home for the first time in a long time like that."
    },
    {
      "duration": 3700,
      "end_time": 1438310,
      "speaker": "Speaker 1",
      "start_time": 1434610,
      "text": "This is where I did start getting more regular massages just because like."
    },
    {
      "duration": 9960,
      "end_time": 1449290,
      "speaker": "Speaker 1",
      "start_time": 1439330,
      "text": "Doing that rehab is tough, man, like how to like run it, like learning how to kind of walk again, but, you know, but learning how to run again is a weird thing when you're."
    },
    {
      "duration": 2640,
      "end_time": 1452130,
      "speaker": "Speaker 1",
      "start_time": 1449490,
      "text": "32 years old is a bizarre."
    },
    {
      "duration": 3000,
      "end_time": 1456650,
      "speaker": "Speaker 1",
      "start_time": 1453650,
      "text": "And so, you know, just the training, like my conditioning wasn't the same."
    },
    {
      "duration": 6140,
      "end_time": 1462890,
      "speaker": "Speaker 1",
      "start_time": 1456750,
      "text": "So like, you know, like I was using like I was using different muscles to help me out and kind of fake it a little bit."
    },
    {
      "duration": 2420,
      "end_time": 1465390,
      "speaker": "Speaker 1",
      "start_time": 1462970,
      "text": "And so I started getting a lot more massages during that time."
    },
    {
      "duration": 3940,
      "end_time": 1470310,
      "speaker": "Speaker 0",
      "start_time": 1466370,
      "text": "What muscles were they specifically working on to help you?"
    },
    {
      "duration": 2240,
      "end_time": 1474290,
      "speaker": "Speaker 1",
      "start_time": 1472050,
      "text": "At the rehab or just in general?"
    },
    {
      "duration": 3140,
      "end_time": 1478070,
      "speaker": "Speaker 0",
      "start_time": 1474930,
      "text": "Both. So during the rehab and then after rehab."
    },
    {
      "duration": 3200,
      "end_time": 1481790,
      "speaker": "Speaker 1",
      "start_time": 1478590,
      "text": "During the rehab, they'd always be like rehab in my."
    },
    {
      "duration": 5380,
      "end_time": 1487350,
      "speaker": "Speaker 1",
      "start_time": 1481970,
      "text": "They'd always be like massaging my like my knee and especially at first. Just around"
    },
    {
      "duration": 1340,
      "end_time": 1488690,
      "speaker": "Speaker 0",
      "start_time": 1487350,
      "text": "The patella or."
    },
    {
      "duration": 3640,
      "end_time": 1492950,
      "speaker": "Speaker 1",
      "start_time": 1489310,
      "text": "Yeah, like right on the kneecap. Yeah. OK. Anywhere else I'd go."
    },
    {
      "duration": 2600,
      "end_time": 1495550,
      "speaker": "Speaker 1",
      "start_time": 1492950,
      "text": "For the most, it would just be like full body massages."
    },
    {
      "duration": 3320,
      "end_time": 1498870,
      "speaker": "Speaker 1",
      "start_time": 1495550,
      "text": "And like I would, of course, tell them like I had knee surgery, whatever, like three months ago."
    },
    {
      "duration": 2560,
      "end_time": 1501550,
      "speaker": "Speaker 1",
      "start_time": 1498990,
      "text": "And so they just would like move me gently."
    },
    {
      "duration": 3440,
      "end_time": 1504990,
      "speaker": "Speaker 1",
      "start_time": 1501550,
      "text": "But like they would they would do the normal like massage my legs."
    },
    {
      "duration": 3720,
      "end_time": 1508710,
      "speaker": "Speaker 1",
      "start_time": 1504990,
      "text": "Not a lot of like stretching during the massage. Right."
    },
    {
      "duration": 3660,
      "end_time": 1512410,
      "speaker": "Speaker 0",
      "start_time": 1508750,
      "text": "No stretching. No traction, especially on the knee. Right. Yeah. Imagine."
    },
    {
      "duration": 5000,
      "end_time": 1517850,
      "speaker": "Speaker 0",
      "start_time": 1512850,
      "text": "Yeah, definitely want to let that let those areas heal before you get back in and can do more work"
    },
    {
      "duration": 320,
      "end_time": 1518170,
      "speaker": "Speaker 1",
      "start_time": 1517850,
      "text": "On those."
    },
    {
      "duration": 5900,
      "end_time": 1524810,
      "speaker": "Speaker 0",
      "start_time": 1518910,
      "text": "After you have rehab, you're back on the road, you're back on TV, you're you're doing your thing."
    },
    {
      "duration": 3580,
      "end_time": 1529090,
      "speaker": "Speaker 0",
      "start_time": 1525510,
      "text": "Can you tell us about the Samoa Joe incident?"
    },
    {
      "duration": 1920,
      "end_time": 1532350,
      "speaker": "Speaker 1",
      "start_time": 1530430,
      "text": "Yeah, it's"
    },
    {
      "duration": 980,
      "end_time": 1533330,
      "speaker": "Speaker 0",
      "start_time": 1532350,
      "text": "The big one, everyone."
    },
    {
      "duration": 1980,
      "end_time": 1535630,
      "speaker": "Speaker 1",
      "start_time": 1533650,
      "text": "Yeah, it's the big one. It's definitely the big one."
    },
    {
      "duration": 5100,
      "end_time": 1541050,
      "speaker": "Speaker 1",
      "start_time": 1535950,
      "text": "Yeah, I was back on the road full time. I was literally. I get hurt on June 1st, 2015."
    },
    {
      "duration": 5600,
      "end_time": 1546650,
      "speaker": "Speaker 1",
      "start_time": 1541050,
      "text": "But from like I wrestle Neville at that first takeover is the end of May 2014."
    },
    {
      "duration": 10160,
      "end_time": 1557050,
      "speaker": "Speaker 1",
      "start_time": 1546890,
      "text": "So like from that, like April, May 2014 to to to June 2015, I had I had a pretty good run for my body of work."
    },
    {
      "duration": 3160,
      "end_time": 1560210,
      "speaker": "Speaker 1",
      "start_time": 1557050,
      "text": "I was very. it's it's my it's my best work."
    },
    {
      "duration": 7120,
      "end_time": 1567430,
      "speaker": "Speaker 1",
      "start_time": 1560310,
      "text": "It's it's my best work by far. And I'm in a way I'm proud of it that I am very proud of."
    },
    {
      "duration": 8760,
      "end_time": 1576190,
      "speaker": "Speaker 1",
      "start_time": 1567430,
      "text": "But in a way, there's a little at least like when I got hurt, I look I try to look at the silver lining, at least like when I got hurt, I hadn't started like descending."
    },
    {
      "duration": 3900,
      "end_time": 1580110,
      "speaker": "Speaker 1",
      "start_time": 1576210,
      "text": "I was still ascending. So like at least like that kind of feels good."
    },
    {
      "duration": 5300,
      "end_time": 1585470,
      "speaker": "Speaker 1",
      "start_time": 1580170,
      "text": "If that makes it a part of it makes it sting a little more where it's like, damn, who knows what that potential could have been?"
    },
    {
      "duration": 5920,
      "end_time": 1591410,
      "speaker": "Speaker 1",
      "start_time": 1585490,
      "text": "But the other part was if I if I had the same neck injury a year earlier, I wouldn't have accomplished that yet."
    },
    {
      "duration": 3440,
      "end_time": 1595050,
      "speaker": "Speaker 1",
      "start_time": 1591610,
      "text": "So like then I don't know, it wouldn't. it wouldn't be the same."
    },
    {
      "duration": 4640,
      "end_time": 1599750,
      "speaker": "Speaker 1",
      "start_time": 1595110,
      "text": "I don't know the match with Joe. Just it came down to."
    },
    {
      "duration": 3960,
      "end_time": 1603710,
      "speaker": "Speaker 1",
      "start_time": 1599750,
      "text": "I took his finish, the muscle buster. And that's"
    },
    {
      "duration": 4280,
      "end_time": 1607990,
      "speaker": "Speaker 0",
      "start_time": 1603710,
      "text": "Where you're. you're up on his shoulder. Your head's right here. And he's my head's"
    },
    {
      "duration": 4780,
      "end_time": 1612770,
      "speaker": "Speaker 1",
      "start_time": 1607990,
      "text": "Inside his shoulder. And he's got my legs. My legs are bent up here and he's got my legs."
    },
    {
      "duration": 4420,
      "end_time": 1618230,
      "speaker": "Speaker 1",
      "start_time": 1613810,
      "text": "And most people's arms are kind of in here. I noticed I have a picture mine."
    },
    {
      "duration": 6200,
      "end_time": 1624990,
      "speaker": "Speaker 1",
      "start_time": 1618790,
      "text": "So if I'm Joe holding like this. I'm actually both my arms are wrapped under his."
    },
    {
      "duration": 5260,
      "end_time": 1630330,
      "speaker": "Speaker 1",
      "start_time": 1625070,
      "text": "So if you look at the picture, your physics, you will absolutely understand why this happened."
    },
    {
      "duration": 4300,
      "end_time": 1634730,
      "speaker": "Speaker 1",
      "start_time": 1630430,
      "text": "I had my arms in the wrong spot. I had never wrestled him before."
    },
    {
      "duration": 3200,
      "end_time": 1638030,
      "speaker": "Speaker 1",
      "start_time": 1634830,
      "text": "We I'd met him a little bit at Christian's house a couple of times."
    },
    {
      "duration": 5200,
      "end_time": 1643290,
      "speaker": "Speaker 1",
      "start_time": 1638090,
      "text": "And I met him in Ring of Honor. One time I wrestled there and he was always even."
    },
    {
      "duration": 3700,
      "end_time": 1647170,
      "speaker": "Speaker 1",
      "start_time": 1643470,
      "text": "Yeah, I just saw him. I just saw him on Thursday and he's sorry Wednesday."
    },
    {
      "duration": 2600,
      "end_time": 1650010,
      "speaker": "Speaker 1",
      "start_time": 1647410,
      "text": "And he's never been anything but a gentleman to me."
    },
    {
      "duration": 5240,
      "end_time": 1655370,
      "speaker": "Speaker 1",
      "start_time": 1650130,
      "text": "It just was one of those things we and when we hit like when you see the picture, you'll know exactly what I'm talking about."
    },
    {
      "duration": 2940,
      "end_time": 1658510,
      "speaker": "Speaker 1",
      "start_time": 1655570,
      "text": "When we hit my just my head has nowhere to go."
    },
    {
      "duration": 7680,
      "end_time": 1666690,
      "speaker": "Speaker 1",
      "start_time": 1659010,
      "text": "All the weight pops up and just and then the ligament holding my C2 in place ruptured like on impact."
    },
    {
      "duration": 6240,
      "end_time": 1674470,
      "speaker": "Speaker 1",
      "start_time": 1668230,
      "text": "And I saw the brightest white light of my life. Like I've been I've been concussed."
    },
    {
      "duration": 4520,
      "end_time": 1679070,
      "speaker": "Speaker 1",
      "start_time": 1674550,
      "text": "I've had a few concussions wrestling. And, you know, you see a little white flash."
    },
    {
      "duration": 6280,
      "end_time": 1685590,
      "speaker": "Speaker 1",
      "start_time": 1679310,
      "text": "This was like a thick, thick white. Like I was going through this light for so long."
    },
    {
      "duration": 6180,
      "end_time": 1691830,
      "speaker": "Speaker 1",
      "start_time": 1685650,
      "text": "I was like, damn. And I was completely paralyzed from the neck down for a few seconds."
    },
    {
      "duration": 1420,
      "end_time": 1693470,
      "speaker": "Speaker 1",
      "start_time": 1692050,
      "text": "Probably. It's"
    },
    {
      "duration": 2760,
      "end_time": 1696230,
      "speaker": "Speaker 0",
      "start_time": 1693470,
      "text": "About to say you actually rolled out of the ring after that, which is. Yeah"
    },
    {
      "duration": 2880,
      "end_time": 1699230,
      "speaker": "Speaker 1",
      "start_time": 1696350,
      "text": "Amazing. Five seconds. I was paralyzed."
    },
    {
      "duration": 5920,
      "end_time": 1706170,
      "speaker": "Speaker 1",
      "start_time": 1700250,
      "text": "And then once I was not once that process went away, like a pretty intense pins and needles."
    },
    {
      "duration": 1000,
      "end_time": 1707370,
      "speaker": "Speaker 1",
      "start_time": 1706370,
      "text": "Right. Like all"
    },
    {
      "duration": 660,
      "end_time": 1708030,
      "speaker": "Speaker 0",
      "start_time": 1707370,
      "text": "That is easier."
    },
    {
      "duration": 1480,
      "end_time": 1710370,
      "speaker": "Speaker 1",
      "start_time": 1708890,
      "text": "Yeah. Now the feeling was coming back."
    },
    {
      "duration": 5040,
      "end_time": 1715550,
      "speaker": "Speaker 1",
      "start_time": 1710510,
      "text": "And then almost like that scene from Alien, where the alien comes out of the stomach."
    },
    {
      "duration": 1960,
      "end_time": 1717510,
      "speaker": "Speaker 1",
      "start_time": 1715550,
      "text": "That's what it felt like was happening in the back of my neck."
    },
    {
      "duration": 7240,
      "end_time": 1724810,
      "speaker": "Speaker 1",
      "start_time": 1717570,
      "text": "It felt like some something was going to shoot through the back of my creature was about to burst out of the back of my neck."
    },
    {
      "duration": 1360,
      "end_time": 1726410,
      "speaker": "Speaker 1",
      "start_time": 1725050,
      "text": "Right. And I can laugh about it now."
    },
    {
      "duration": 4320,
      "end_time": 1731070,
      "speaker": "Speaker 1",
      "start_time": 1726750,
      "text": "But eight years ago, I definitely didn't have a smile on my face. Well, this was going down. No"
    },
    {
      "duration": 3740,
      "end_time": 1734890,
      "speaker": "Speaker 0",
      "start_time": 1731150,
      "text": "I sent you a text. I think when you were in the hospital, I didn't."
    },
    {
      "duration": 4840,
      "end_time": 1739750,
      "speaker": "Speaker 0",
      "start_time": 1734910,
      "text": "I had no idea until like two days later. I'm like, are you OK? You said, I'm fine. I'm fine."
    },
    {
      "duration": 2300,
      "end_time": 1742490,
      "speaker": "Speaker 0",
      "start_time": 1740190,
      "text": "Like, I don't think you were fine. So what after?"
    },
    {
      "duration": 2780,
      "end_time": 1745270,
      "speaker": "Speaker 0",
      "start_time": 1742490,
      "text": "After that happened? Obviously, you go to the hospital, right?"
    },
    {
      "duration": 6420,
      "end_time": 1752190,
      "speaker": "Speaker 0",
      "start_time": 1745770,
      "text": "How quickly after you get to the hospital, do they get you into surgery to get that fixed? So"
    },
    {
      "duration": 2140,
      "end_time": 1754330,
      "speaker": "Speaker 1",
      "start_time": 1752190,
      "text": "I get hurt. I go to the hospital."
    },
    {
      "duration": 2560,
      "end_time": 1758410,
      "speaker": "Speaker 1",
      "start_time": 1755850,
      "text": "They do, I believe, a CAT scan."
    },
    {
      "duration": 4760,
      "end_time": 1764570,
      "speaker": "Speaker 1",
      "start_time": 1759810,
      "text": "And then they just I'm sitting down and then almost like a SWAT team."
    },
    {
      "duration": 6080,
      "end_time": 1770950,
      "speaker": "Speaker 1",
      "start_time": 1764870,
      "text": "Oh, this like group of medics come in and they're like, don't move. And they like they cut my."
    },
    {
      "duration": 2320,
      "end_time": 1773270,
      "speaker": "Speaker 1",
      "start_time": 1770950,
      "text": "I remember they're like, we're going to have to cut your shirt off, sir."
    },
    {
      "duration": 4740,
      "end_time": 1778110,
      "speaker": "Speaker 1",
      "start_time": 1773370,
      "text": "And I was like, yeah, I can just take it off. Like, no, don't move. And they like cut my shirt off."
    },
    {
      "duration": 4820,
      "end_time": 1783150,
      "speaker": "Speaker 1",
      "start_time": 1778330,
      "text": "They were intense and they were bringing me to a different place that specializes in cervical injuries."
    },
    {
      "duration": 3540,
      "end_time": 1787370,
      "speaker": "Speaker 1",
      "start_time": 1783830,
      "text": "And so they brought me there then. But there wasn't a room for me."
    },
    {
      "duration": 4200,
      "end_time": 1791730,
      "speaker": "Speaker 1",
      "start_time": 1787530,
      "text": "So I there's a bed. I slept in a bed by sleep."
    },
    {
      "duration": 7440,
      "end_time": 1799290,
      "speaker": "Speaker 1",
      "start_time": 1791850,
      "text": "I mean, I laid in it in the basement of this hospital, man, freezing, no real phone service, like one bar."
    },
    {
      "duration": 4380,
      "end_time": 1803990,
      "speaker": "Speaker 1",
      "start_time": 1799610,
      "text": "If I moved it in the right spot. Oh, here we go. I got one. It was pretty horrible."
    },
    {
      "duration": 1400,
      "end_time": 1805450,
      "speaker": "Speaker 1",
      "start_time": 1804050,
      "text": "And the doctor came in in the morning."
    },
    {
      "duration": 3859,
      "end_time": 1810469,
      "speaker": "Speaker 1",
      "start_time": 1806610,
      "text": "I always say this, he might need a course on how to talk to people, but."
    },
    {
      "duration": 1879,
      "end_time": 1812669,
      "speaker": "Speaker 0",
      "start_time": 1810790,
      "text": "Bedside manner, not the best."
    },
    {
      "duration": 2060,
      "end_time": 1814850,
      "speaker": "Speaker 1",
      "start_time": 1812790,
      "text": "But he at least hit me with the truth."
    },
    {
      "duration": 3600,
      "end_time": 1818610,
      "speaker": "Speaker 1",
      "start_time": 1815010,
      "text": "He came walking in, man, it might be, I feel like it's like 10 a.m."
    },
    {
      "duration": 8200,
      "end_time": 1827389,
      "speaker": "Speaker 1",
      "start_time": 1819189,
      "text": "Cesaro just got there with my Starbucks order and my Chipotle order, which I promise you he knows to this day because he just wired like a madman."
    },
    {
      "duration": 4260,
      "end_time": 1832010,
      "speaker": "Speaker 1",
      "start_time": 1827750,
      "text": "And he's a truly a great human and a great, great friend."
    },
    {
      "duration": 5079,
      "end_time": 1837689,
      "speaker": "Speaker 1",
      "start_time": 1832610,
      "text": "So he's in there and the doctor comes in and he said, hey, we have to do emergency surgery."
    },
    {
      "duration": 4220,
      "end_time": 1842129,
      "speaker": "Speaker 1",
      "start_time": 1837909,
      "text": "He's like, you have a C2 injury. We have to fuse your C1 and C2."
    },
    {
      "duration": 5540,
      "end_time": 1848530,
      "speaker": "Speaker 1",
      "start_time": 1842990,
      "text": "And he said, your wrestling career is over. And I was like, oh, hi, nice to meet you too."
    },
    {
      "duration": 2921,
      "end_time": 1852350,
      "speaker": "Speaker 0",
      "start_time": 1849429,
      "text": "Well, you know, at least he didn't let"
    },
    {
      "duration": 500,
      "end_time": 1852850,
      "speaker": "Speaker 1",
      "start_time": 1852350,
      "text": "You"
    },
    {
      "duration": 1240,
      "end_time": 1854090,
      "speaker": "Speaker 0",
      "start_time": 1852850,
      "text": "Get your hopes up, you know."
    },
    {
      "duration": 10220,
      "end_time": 1865090,
      "speaker": "Speaker 1",
      "start_time": 1854870,
      "text": "But here's the thing, man, when I experienced that paralysis and when I sat there that whole night with just the pain in my neck, I knew that, I knew I would never wrestle again."
    },
    {
      "duration": 3000,
      "end_time": 1868770,
      "speaker": "Speaker 1",
      "start_time": 1865770,
      "text": "So when the doctor said it to me, I was so numb at the time."
    },
    {
      "duration": 5920,
      "end_time": 1875750,
      "speaker": "Speaker 1",
      "start_time": 1869830,
      "text": "Cesaro's the one who starts to kind of wipe in his eyes. He was, that's how upset he was for me."
    },
    {
      "duration": 1240,
      "end_time": 1877550,
      "speaker": "Speaker 0",
      "start_time": 1876310,
      "text": "I'd"
    },
    {
      "duration": 7320,
      "end_time": 1884870,
      "speaker": "Speaker 1",
      "start_time": 1877550,
      "text": "Come to that realization while I was sitting there, you know, by this point it had been over 12 hours that I'd been hurt."
    },
    {
      "duration": 3581,
      "end_time": 1889030,
      "speaker": "Speaker 1",
      "start_time": 1885449,
      "text": "So anyway, he did wanna do surgery like right away. Then Natty was very funny."
    },
    {
      "duration": 1141,
      "end_time": 1890290,
      "speaker": "Speaker 1",
      "start_time": 1889149,
      "text": "She said, hold on, are you the best?"
    },
    {
      "duration": 6179,
      "end_time": 1896469,
      "speaker": "Speaker 1",
      "start_time": 1890290,
      "text": "And to his credit, so he might need, he might need a little lesson on how to break bad news to people."
    },
    {
      "duration": 2961,
      "end_time": 1899610,
      "speaker": "Speaker 1",
      "start_time": 1896649,
      "text": "But he also, but he has great self-awareness."
    },
    {
      "duration": 4240,
      "end_time": 1903929,
      "speaker": "Speaker 1",
      "start_time": 1899689,
      "text": "Natty said, hold on, we have access to the best through WWE. Are you the best person?"
    },
    {
      "duration": 4439,
      "end_time": 1909209,
      "speaker": "Speaker 1",
      "start_time": 1904770,
      "text": "Because this is obviously a really bad injury. And he said, he said, I can do this surgery."
    },
    {
      "duration": 1341,
      "end_time": 1910730,
      "speaker": "Speaker 1",
      "start_time": 1909389,
      "text": "He said, but to be honest, I'm not the best."
    },
    {
      "duration": 3299,
      "end_time": 1914669,
      "speaker": "Speaker 1",
      "start_time": 1911370,
      "text": "Natty said, well then, I'm sorry, but I don't think we'll."
    },
    {
      "duration": 12760,
      "end_time": 1927949,
      "speaker": "Speaker 1",
      "start_time": 1915189,
      "text": "So then what he was gonna do, he was gonna let me like, he was gonna let me, give me like a, you know, authorized, like he was gonna let me leave the hospital and then come back in a, I had to promise him I wouldn't do anything."
    },
    {
      "duration": 1439,
      "end_time": 1929689,
      "speaker": "Speaker 1",
      "start_time": 1928250,
      "text": "And then- They need"
    },
    {
      "duration": 2641,
      "end_time": 1932330,
      "speaker": "Speaker 0",
      "start_time": 1929689,
      "text": "To do emergency surgery, but they'll let you leave the hospital."
    },
    {
      "duration": 1840,
      "end_time": 1935370,
      "speaker": "Speaker 1",
      "start_time": 1933530,
      "text": "This is what he decided this moment. Doesn't"
    },
    {
      "duration": 860,
      "end_time": 1936230,
      "speaker": "Speaker 0",
      "start_time": 1935370,
      "text": "Make a lot of sense. But"
    },
    {
      "duration": 3399,
      "end_time": 1939629,
      "speaker": "Speaker 1",
      "start_time": 1936230,
      "text": "Then when he found out that I didn't live in San Antonio, he changed his mind."
    },
    {
      "duration": 2260,
      "end_time": 1941929,
      "speaker": "Speaker 1",
      "start_time": 1939669,
      "text": "And I wasn't allowed to leave. So they had to get an airlift."
    },
    {
      "duration": 3881,
      "end_time": 1946090,
      "speaker": "Speaker 1",
      "start_time": 1942209,
      "text": "The airlift, the surgeon happened to be here in Tampa. Now he's in Phoenix."
    },
    {
      "duration": 3300,
      "end_time": 1949709,
      "speaker": "Speaker 1",
      "start_time": 1946409,
      "text": "Dr. Uribe, but he just happened to be in Tampa."
    },
    {
      "duration": 5320,
      "end_time": 1955209,
      "speaker": "Speaker 1",
      "start_time": 1949889,
      "text": "So then I'm sitting in that hospital in San Antonio for a few days, waiting on an airlift."
    },
    {
      "duration": 4980,
      "end_time": 1960290,
      "speaker": "Speaker 1",
      "start_time": 1955310,
      "text": "But I did get a room that Tuesday morning. They brought me up to a room. So I had that."
    },
    {
      "duration": 6860,
      "end_time": 1968110,
      "speaker": "Speaker 0",
      "start_time": 1961250,
      "text": "So how long was the rehab for that injury? And what kind of rehab were they having? You do?"
    },
    {
      "duration": 1261,
      "end_time": 1969750,
      "speaker": "Speaker 1",
      "start_time": 1968489,
      "text": "There was no real rehab."
    },
    {
      "duration": 4841,
      "end_time": 1975310,
      "speaker": "Speaker 1",
      "start_time": 1970469,
      "text": "Yeah, it just was, they're like, hey, so this injury is gonna be different than what you've had before."
    },
    {
      "duration": 1159,
      "end_time": 1976909,
      "speaker": "Speaker 1",
      "start_time": 1975750,
      "text": "This one's the opposite."
    },
    {
      "duration": 7500,
      "end_time": 1984649,
      "speaker": "Speaker 1",
      "start_time": 1977149,
      "text": "Instead of like, like with the knee, they put that tissue, they used my patella tendon to make a new ACL in my knee."
    },
    {
      "duration": 7640,
      "end_time": 1992750,
      "speaker": "Speaker 1",
      "start_time": 1985110,
      "text": "So you're introducing, it's your body's tissue, but you're now making this new thing and you gotta stretch it."
    },
    {
      "duration": 2480,
      "end_time": 1995449,
      "speaker": "Speaker 1",
      "start_time": 1992969,
      "text": "And with the neck was very different. They said, it's the opposite."
    },
    {
      "duration": 2599,
      "end_time": 1998169,
      "speaker": "Speaker 1",
      "start_time": 1995570,
      "text": "We don't want you moving. You gotta let that bone fuse."
    },
    {
      "duration": 4760,
      "end_time": 2003810,
      "speaker": "Speaker 1",
      "start_time": 1999050,
      "text": "But when the surgeon went in, he was like, two things, he said, wow."
    },
    {
      "duration": 4141,
      "end_time": 2008610,
      "speaker": "Speaker 1",
      "start_time": 2004469,
      "text": "The surgery he thought was maybe gonna be about two, two and a half hours. It was four and a half."
    },
    {
      "duration": 5839,
      "end_time": 2015449,
      "speaker": "Speaker 1",
      "start_time": 2009610,
      "text": "And he said, two things were, he said, man, your head had no stability when I went in there."
    },
    {
      "duration": 980,
      "end_time": 2016449,
      "speaker": "Speaker 1",
      "start_time": 2015469,
      "text": "He's like, it was a bobble head."
    },
    {
      "duration": 7159,
      "end_time": 2023689,
      "speaker": "Speaker 1",
      "start_time": 2016530,
      "text": "He's like, and he said what took so long was going, cause he went through the back and the rear and he didn't want to cut through the muscle and damage it."
    },
    {
      "duration": 7419,
      "end_time": 2031189,
      "speaker": "Speaker 1",
      "start_time": 2023770,
      "text": "So he was gently like combing. And he said, you have such a dense amount of muscle in your neck."
    },
    {
      "duration": 3960,
      "end_time": 2035149,
      "speaker": "Speaker 1",
      "start_time": 2031189,
      "text": "He said, okay, let's take religious stuff. Let's take God out of it."
    },
    {
      "duration": 5361,
      "end_time": 2040850,
      "speaker": "Speaker 1",
      "start_time": 2035489,
      "text": "He said, I would chalk your, the only reason you survived this is due to the muscle in your neck."
    },
    {
      "duration": 6720,
      "end_time": 2047590,
      "speaker": "Speaker 1",
      "start_time": 2040870,
      "text": "He's like, but he kind of insinuated it was, he felt it was more God than the muscle in my neck. All"
    },
    {
      "duration": 1359,
      "end_time": 2048949,
      "speaker": "Speaker 0",
      "start_time": 2047590,
      "text": "Right. That's"
    },
    {
      "duration": 421,
      "end_time": 2049370,
      "speaker": "Speaker 1",
      "start_time": 2048949,
      "text": "His belief."
    },
    {
      "duration": 4261,
      "end_time": 2054370,
      "speaker": "Speaker 0",
      "start_time": 2050109,
      "text": "All right, so rehab, essentially, you're just keeping your neck still, right? Yeah"
    },
    {
      "duration": 1181,
      "end_time": 2055670,
      "speaker": "Speaker 1",
      "start_time": 2054489,
      "text": "I had the collar."
    },
    {
      "duration": 5320,
      "end_time": 2061190,
      "speaker": "Speaker 1",
      "start_time": 2055870,
      "text": "So I get the surgery about three weeks after the injury, but I'm at home every day, like doing nothing."
    },
    {
      "duration": 900,
      "end_time": 2062210,
      "speaker": "Speaker 1",
      "start_time": 2061310,
      "text": "I just have like the collar."
    },
    {
      "duration": 4940,
      "end_time": 2067230,
      "speaker": "Speaker 1",
      "start_time": 2062290,
      "text": "I was doing some, like I was allowed to go to the gym, but you have to wear the collar everywhere."
    },
    {
      "duration": 7880,
      "end_time": 2075409,
      "speaker": "Speaker 1",
      "start_time": 2067529,
      "text": "It's also, not only is it helping me, it's also a little bit of a billboard of like, hey, this guy, there's certainly something a little bit wrong."
    },
    {
      "duration": 2000,
      "end_time": 2077509,
      "speaker": "Speaker 1",
      "start_time": 2075509,
      "text": "So like, don't bump into, you know what I mean?"
    },
    {
      "duration": 2701,
      "end_time": 2080630,
      "speaker": "Speaker 1",
      "start_time": 2077929,
      "text": "So I was allowed to do like some stationary bike, but I had to be very careful."
    },
    {
      "duration": 3299,
      "end_time": 2084029,
      "speaker": "Speaker 1",
      "start_time": 2080730,
      "text": "I'd only go to the gym with like with Natty, but otherwise I don't."
    },
    {
      "duration": 2480,
      "end_time": 2086710,
      "speaker": "Speaker 1",
      "start_time": 2084230,
      "text": "And then I wear that brace for another three months post-surgery."
    },
    {
      "duration": 4519,
      "end_time": 2091389,
      "speaker": "Speaker 1",
      "start_time": 2086870,
      "text": "So I wear it for three weeks prior and then three months post. So almost four months of that collar."
    },
    {
      "duration": 10520,
      "end_time": 2102250,
      "speaker": "Speaker 1",
      "start_time": 2091730,
      "text": "If you want to either, if you have a worst enemy, you want to torture, or if you have a friend that you want to test your friendship and see if maybe they will be your enemy, put that collar on them for four months and see what happens."
    },
    {
      "duration": 380,
      "end_time": 2102810,
      "speaker": "Speaker 1",
      "start_time": 2102430,
      "text": "Exactly."
    },
    {
      "duration": 3581,
      "end_time": 2107130,
      "speaker": "Speaker 0",
      "start_time": 2103549,
      "text": "Yeah, it doesn't seem like something I'd enjoy personally."
    },
    {
      "duration": 1020,
      "end_time": 2108450,
      "speaker": "Speaker 1",
      "start_time": 2107430,
      "text": "Horrible, it's horrible."
    },
    {
      "duration": 3820,
      "end_time": 2112690,
      "speaker": "Speaker 0",
      "start_time": 2108870,
      "text": "So what kind of massage do you receive now?"
    },
    {
      "duration": 5500,
      "end_time": 2118549,
      "speaker": "Speaker 0",
      "start_time": 2113049,
      "text": "Since you're retired, you're not, I mean, obviously you're still exercising, lifting weights, doing cardio."
    },
    {
      "duration": 5480,
      "end_time": 2124410,
      "speaker": "Speaker 0",
      "start_time": 2118930,
      "text": "Are there specific things that you try to do now or is it just kind of whatever?"
    },
    {
      "duration": 2020,
      "end_time": 2127390,
      "speaker": "Speaker 1",
      "start_time": 2125370,
      "text": "Now I get more massages than ever."
    },
    {
      "duration": 3261,
      "end_time": 2130830,
      "speaker": "Speaker 1",
      "start_time": 2127569,
      "text": "And it's a lot of, I have a guy here that comes twice a week and works on me."
    },
    {
      "duration": 2260,
      "end_time": 2133130,
      "speaker": "Speaker 1",
      "start_time": 2130870,
      "text": "He does like a bunch of adrenal stuff."
    },
    {
      "duration": 5880,
      "end_time": 2139690,
      "speaker": "Speaker 1",
      "start_time": 2133810,
      "text": "Most of it's very light to the touch stuff, but it like, I don't know, man, it's almost other worldly."
    },
    {
      "duration": 7040,
      "end_time": 2147310,
      "speaker": "Speaker 1",
      "start_time": 2140270,
      "text": "I'll just like, I will get some of the best, deepest like little maybe 20 or even hour long naps ever."
    },
    {
      "duration": 3799,
      "end_time": 2152029,
      "speaker": "Speaker 1",
      "start_time": 2148230,
      "text": "It's wild, his stuff. And I felt really good ever since he started working on me."
    },
    {
      "duration": 3780,
      "end_time": 2155870,
      "speaker": "Speaker 1",
      "start_time": 2152090,
      "text": "And I get a lot of deep tissue massages and sports massages."
    },
    {
      "duration": 3961,
      "end_time": 2160470,
      "speaker": "Speaker 1",
      "start_time": 2156509,
      "text": "I have a guy that comes here usually once a week or once every two weeks."
    },
    {
      "duration": 5701,
      "end_time": 2166230,
      "speaker": "Speaker 1",
      "start_time": 2160529,
      "text": "And then I have two memberships at two different massage places, 20 minutes from me."
    },
    {
      "duration": 2460,
      "end_time": 2168730,
      "speaker": "Speaker 1",
      "start_time": 2166270,
      "text": "So I mean, I'm getting massages all the time."
    },
    {
      "duration": 4240,
      "end_time": 2173230,
      "speaker": "Speaker 0",
      "start_time": 2168990,
      "text": "All the time. And Natty's still on the road. So is she"
    },
    {
      "duration": 2060,
      "end_time": 2175290,
      "speaker": "Speaker 1",
      "start_time": 2173230,
      "text": "Getting massages? And she's getting massages all the time too."
    },
    {
      "duration": 4881,
      "end_time": 2180890,
      "speaker": "Speaker 1",
      "start_time": 2176009,
      "text": "Like I wish I'd gotten done this type of maintenance while I was on the road."
    },
    {
      "duration": 5080,
      "end_time": 2186109,
      "speaker": "Speaker 1",
      "start_time": 2181029,
      "text": "I'm glad I'm doing it now. And I feel really good, all things considered, especially I feel amazing."
    },
    {
      "duration": 5260,
      "end_time": 2191750,
      "speaker": "Speaker 1",
      "start_time": 2186490,
      "text": "But I wish I had been smart enough to do this while I was a in-ring performer."
    },
    {
      "duration": 240,
      "end_time": 2192450,
      "speaker": "Speaker 0",
      "start_time": 2192210,
      "text": "Exactly."
    },
    {
      "duration": 5460,
      "end_time": 2198509,
      "speaker": "Speaker 0",
      "start_time": 2193049,
      "text": "So when you get massages, do you just kind of trust the massage therapist and what they want to do?"
    },
    {
      "duration": 3020,
      "end_time": 2201690,
      "speaker": "Speaker 0",
      "start_time": 2198670,
      "text": "Or do you develop kind of a treatment plan with the therapist?"
    },
    {
      "duration": 3300,
      "end_time": 2205750,
      "speaker": "Speaker 1",
      "start_time": 2202450,
      "text": "Like sometimes I'll just like book, I'll be like, you know, I'm tired from this flight."
    },
    {
      "duration": 2600,
      "end_time": 2208910,
      "speaker": "Speaker 1",
      "start_time": 2206310,
      "text": "From, I'm going to book a massage when I get home."
    },
    {
      "duration": 3641,
      "end_time": 2212710,
      "speaker": "Speaker 1",
      "start_time": 2209069,
      "text": "And I was booking a massage and sometimes I'm not able to get in with like my regular people."
    },
    {
      "duration": 4060,
      "end_time": 2216990,
      "speaker": "Speaker 1",
      "start_time": 2212930,
      "text": "So if it's someone that I haven't really worked with, I will tell them that I had neck surgery."
    },
    {
      "duration": 3621,
      "end_time": 2220650,
      "speaker": "Speaker 1",
      "start_time": 2217029,
      "text": "I'll be like, it's a long time ago. And obviously you'll see the scar or whatever, but."
    },
    {
      "duration": 4360,
      "end_time": 2225210,
      "speaker": "Speaker 1",
      "start_time": 2220850,
      "text": "Right. Everyone that's worked on it has been pretty good."
    },
    {
      "duration": 5101,
      "end_time": 2231130,
      "speaker": "Speaker 0",
      "start_time": 2226029,
      "text": "With the neck injury specifically, are there any precautions that the therapists take with you?"
    },
    {
      "duration": 3021,
      "end_time": 2235130,
      "speaker": "Speaker 0",
      "start_time": 2232109,
      "text": "Or obviously not, probably not a lot of traction going on in the neck."
    },
    {
      "duration": 4300,
      "end_time": 2239430,
      "speaker": "Speaker 1",
      "start_time": 2235130,
      "text": "Yeah, yeah. Not a lot of traction, not too much like movement or stretching."
    },
    {
      "duration": 4760,
      "end_time": 2244410,
      "speaker": "Speaker 1",
      "start_time": 2239650,
      "text": "Like both of my massage girls, they both are big into a lot of stretching."
    },
    {
      "duration": 1980,
      "end_time": 2246390,
      "speaker": "Speaker 1",
      "start_time": 2244410,
      "text": "They do a lot with the legs and the arms."
    },
    {
      "duration": 4199,
      "end_time": 2251069,
      "speaker": "Speaker 1",
      "start_time": 2246870,
      "text": "With the neck, they are very gentle in terms of the stretching."
    },
    {
      "duration": 8480,
      "end_time": 2259670,
      "speaker": "Speaker 1",
      "start_time": 2251190,
      "text": "Like they will stretch, but they will like, they will gently, gently, and they'll get me like kind of it, but it's nothing, they're not, it's nothing, no, not forceful or anything."
    },
    {
      "duration": 400,
      "end_time": 2260390,
      "speaker": "Speaker 1",
      "start_time": 2259990,
      "text": "Awesome."
    },
    {
      "duration": 1460,
      "end_time": 2262069,
      "speaker": "Speaker 0",
      "start_time": 2260609,
      "text": "And that's all communication."
    },
    {
      "duration": 5440,
      "end_time": 2267630,
      "speaker": "Speaker 0",
      "start_time": 2262190,
      "text": "You communicated what happened in the past and they know to just kind of watch out for that, right?"
    },
    {
      "duration": 519,
      "end_time": 2268509,
      "speaker": "Speaker 0",
      "start_time": 2267990,
      "text": "The"
    },
    {
      "duration": 5301,
      "end_time": 2273810,
      "speaker": "Speaker 1",
      "start_time": 2268509,
      "text": "One girl, I didn't know what happened. My neck, it was post-surgery and my neck, something happened."
    },
    {
      "duration": 4361,
      "end_time": 2278370,
      "speaker": "Speaker 1",
      "start_time": 2274009,
      "text": "A guy was talking to me at the grocery store. And when I turned, something got caught."
    },
    {
      "duration": 3921,
      "end_time": 2282470,
      "speaker": "Speaker 1",
      "start_time": 2278549,
      "text": "And I just felt like my body gets so tight for like three days, like yawning."
    },
    {
      "duration": 4020,
      "end_time": 2286950,
      "speaker": "Speaker 1",
      "start_time": 2282930,
      "text": "If I had yawned, it would hurt my neck so much. And I went and saw my massage girl."
    },
    {
      "duration": 2821,
      "end_time": 2289870,
      "speaker": "Speaker 1",
      "start_time": 2287049,
      "text": "And at this point, I just am developing this relationship with her."
    },
    {
      "duration": 2741,
      "end_time": 2292770,
      "speaker": "Speaker 1",
      "start_time": 2290029,
      "text": "And I'm explaining to her what's going on and she's working on me."
    },
    {
      "duration": 4819,
      "end_time": 2298029,
      "speaker": "Speaker 1",
      "start_time": 2293210,
      "text": "And as she's working on me, she like, she working on my back and stuff. And now she's on my neck."
    },
    {
      "duration": 5601,
      "end_time": 2303710,
      "speaker": "Speaker 1",
      "start_time": 2298109,
      "text": "And all of a sudden you feel this like, I was like, oh, I was like, that feels so amazing."
    },
    {
      "duration": 5460,
      "end_time": 2309170,
      "speaker": "Speaker 1",
      "start_time": 2303710,
      "text": "And she said, oh, your, she said my ligament was stuck on a screw. Okay."
    },
    {
      "duration": 2319,
      "end_time": 2311549,
      "speaker": "Speaker 1",
      "start_time": 2309230,
      "text": "Ligament in my neck was stuck on one of the screws in my neck."
    },
    {
      "duration": 7660,
      "end_time": 2319450,
      "speaker": "Speaker 1",
      "start_time": 2311790,
      "text": "And when I saw my surgeon for my six month checkup, I explained that to him and it happened just prior, maybe a four month mark or something."
    },
    {
      "duration": 3219,
      "end_time": 2323149,
      "speaker": "Speaker 1",
      "start_time": 2319930,
      "text": "And he said, oh yeah, that's pretty common. Right. Which I didn't know."
    },
    {
      "duration": 7680,
      "end_time": 2330890,
      "speaker": "Speaker 1",
      "start_time": 2323210,
      "text": "But like, I felt, I thought she was like, I thought she was like the best, like voodoo miracle worker of all time when she got that tendon off that screw."
    },
    {
      "duration": 6320,
      "end_time": 2337750,
      "speaker": "Speaker 0",
      "start_time": 2331430,
      "text": "Got it. Okay. So I think that's, those are all the questions I have."
    },
    {
      "duration": 5400,
      "end_time": 2343230,
      "speaker": "Speaker 0",
      "start_time": 2337830,
      "text": "Do you have any massage therapists or anything you want to plug while you're here? Oh"
    },
    {
      "duration": 1940,
      "end_time": 2345170,
      "speaker": "Speaker 1",
      "start_time": 2343230,
      "text": "Man, I wish I knew like their last names."
    },
    {
      "duration": 9920,
      "end_time": 2355090,
      "speaker": "Speaker 1",
      "start_time": 2345170,
      "text": "There's this, the girl, Corey, I massage Genby in New Tampa and Ivy in Hand and Stone in New Tampa."
    },
    {
      "duration": 4960,
      "end_time": 2360270,
      "speaker": "Speaker 1",
      "start_time": 2355310,
      "text": "And then my guy, Matt, but he's like, he kind of works in NXT a little bit."
    },
    {
      "duration": 6020,
      "end_time": 2366730,
      "speaker": "Speaker 1",
      "start_time": 2360710,
      "text": "He, this guy's just, he works on everybody. Like Corbin, he works on like the roster."
    },
    {
      "duration": 3541,
      "end_time": 2370550,
      "speaker": "Speaker 1",
      "start_time": 2367009,
      "text": "Matt, he works on at least half the roster, keeping us all going, so."
    },
    {
      "duration": 1500,
      "end_time": 2372590,
      "speaker": "Speaker 0",
      "start_time": 2371090,
      "text": "Sounds like he's pretty busy then."
    },
    {
      "duration": 720,
      "end_time": 2373770,
      "speaker": "Speaker 1",
      "start_time": 2373050,
      "text": "They're busy people."
    },
    {
      "duration": 3620,
      "end_time": 2377710,
      "speaker": "Speaker 0",
      "start_time": 2374090,
      "text": "Okay. Do you have any, anything you want to plug while you're here?"
    },
    {
      "duration": 2600,
      "end_time": 2380450,
      "speaker": "Speaker 0",
      "start_time": 2377850,
      "text": "Any social media, anything like that?"
    },
    {
      "duration": 6000,
      "end_time": 2386770,
      "speaker": "Speaker 1",
      "start_time": 2380770,
      "text": "I mean, I'm on Instagram. I'm at TJWilson711. TJWilson711. It's my birthday."
    },
    {
      "duration": 1801,
      "end_time": 2388830,
      "speaker": "Speaker 1",
      "start_time": 2387029,
      "text": "Right. And I'm on Twitter."
    },
    {
      "duration": 3161,
      "end_time": 2392170,
      "speaker": "Speaker 0",
      "start_time": 2389009,
      "text": "I thought you just love slushies, that's it. Or slurpees, excuse me"
    },
    {
      "duration": 120,
      "end_time": 2392410,
      "speaker": "Speaker 1",
      "start_time": 2392290,
      "text": "Slurpees."
    },
    {
      "duration": 4440,
      "end_time": 2397910,
      "speaker": "Speaker 1",
      "start_time": 2393470,
      "text": "Or, and then I'm on X or Twitter, whatever it is today, at TJWilson."
    },
    {
      "duration": 4279,
      "end_time": 2402529,
      "speaker": "Speaker 1",
      "start_time": 2398250,
      "text": "And then I have Workhorse Fitness as well, but."
    },
    {
      "duration": 4021,
      "end_time": 2407550,
      "speaker": "Speaker 0",
      "start_time": 2403529,
      "text": "That's like fitness related products, supplements, stuff like that, right?"
    },
    {
      "duration": 841,
      "end_time": 2408990,
      "speaker": "Speaker 1",
      "start_time": 2408149,
      "text": "Yeah. Yeah."
    },
    {
      "duration": 15841,
      "end_time": 2424950,
      "speaker": "Speaker 1",
      "start_time": 2409109,
      "text": "And it's really, it's really just, it's, I guess it's more of a, it is, it is those things, but what we're kind of developed, like the little community that we have of it is, it's developing almost like making yourself better, like getting, you know, just whatever that is."
    },
    {
      "duration": 9820,
      "end_time": 2434770,
      "speaker": "Speaker 1",
      "start_time": 2424950,
      "text": "If it's working out more, if it's, you know, taking care of yourself more, you know, just being more, a little bit more tentative to your body's needs."
    },
    {
      "duration": 3039,
      "end_time": 2438029,
      "speaker": "Speaker 0",
      "start_time": 2434990,
      "text": "Getting more massages. Getting more massages, of course."
    },
    {
      "duration": 360,
      "end_time": 2438490,
      "speaker": "Speaker 1",
      "start_time": 2438130,
      "text": "Absolutely."
    },
    {
      "duration": 2979,
      "end_time": 2442149,
      "speaker": "Speaker 0",
      "start_time": 2439170,
      "text": "So TJ, it's been a great talking to you. My"
    },
    {
      "duration": 380,
      "end_time": 2442529,
      "speaker": "Speaker 1",
      "start_time": 2442149,
      "text": "Pleasure."
    },
    {
      "duration": 4119,
      "end_time": 2447009,
      "speaker": "Speaker 0",
      "start_time": 2442890,
      "text": "Sorry to keep you so long. Just a lot to talk about, of course. Thanks a lot."
    },
    {
      "duration": 1959,
      "end_time": 2449509,
      "speaker": "Speaker 1",
      "start_time": 2447550,
      "text": "So"
    },
    {
      "duration": 5160,
      "end_time": 2464430,
      "speaker": "Speaker 0",
      "start_time": 2459270,
      "text": "That is going to wrap up this episode of the MBLEX Test Prep Podcast."
    },
    {
      "duration": 3020,
      "end_time": 2467690,
      "speaker": "Speaker 0",
      "start_time": 2464670,
      "text": "I hope you enjoyed the interview. I enjoyed conducting the interview."
    },
    {
      "duration": 3719,
      "end_time": 2471609,
      "speaker": "Speaker 0",
      "start_time": 2467890,
      "text": "Good luck to TJ and all of his future endeavors, of course."
    },
    {
      "duration": 2220,
      "end_time": 2474190,
      "speaker": "Speaker 0",
      "start_time": 2471970,
      "text": "So definitely check out mblextestprep.com."
    },
    {
      "duration": 6160,
      "end_time": 2480430,
      "speaker": "Speaker 0",
      "start_time": 2474270,
      "text": "Check out my study guides, my app, my tutoring packages, everything I have for you as you prepare for the MBLEX."
    },
    {
      "duration": 1480,
      "end_time": 2482190,
      "speaker": "Speaker 0",
      "start_time": 2480710,
      "text": "Until next time, this is David."
    }
  ]
}
